var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g, _g2, _path61, _path62, _path63, _path64, _path65, _g3, _g4, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _circle, _path80, _g5, _g6, _g7, _path81, _path82, _path83, _path84, _rect, _path85, _path86, _g8, _g9, _path87, _g10, _path88, _g11, _path89, _g12, _path90, _g13, _path91, _g14, _path92, _path93, _g15, _path94, _path95, _path96, _g16, _path97, _path98, _path99, _g17, _path100, _path101, _path102, _g18, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _ellipse, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _rect2, _rect3, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _g19, _polygon, _path168, _polygon2, _polygon3, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "183.37px",
    height: "122px",
    viewBox: "0 0 183.37 122",
    style: {
      enableBackground: "new 0 0 183.37 122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.5;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{opacity:0.6;}\r\n\t.st5{fill:url(#SVGID_3_);}\r\n\t.st6{fill:url(#SVGID_4_);}\r\n\t.st7{fill:url(#SVGID_5_);}\r\n\t.st8{fill:url(#SVGID_6_);}\r\n\t.st9{fill:url(#SVGID_7_);}\r\n\t.st10{fill:url(#SVGID_8_);}\r\n\t.st11{fill:url(#SVGID_9_);}\r\n\t.st12{fill:url(#SVGID_10_);}\r\n\t.st13{fill:url(#SVGID_11_);}\r\n\t.st14{fill:url(#SVGID_12_);}\r\n\t.st15{fill:url(#SVGID_13_);}\r\n\t.st16{opacity:0.6;fill:#FFFFFF;}\r\n\t.st17{fill:#DEC3DF;}\r\n\t.st18{fill:url(#SVGID_14_);}\r\n\t.st19{fill:url(#SVGID_15_);}\r\n\t.st20{fill:url(#SVGID_16_);}\r\n\t.st21{fill:url(#SVGID_17_);}\r\n\t.st22{fill:url(#SVGID_18_);}\r\n\t.st23{fill:url(#SVGID_19_);}\r\n\t.st24{fill:url(#SVGID_20_);}\r\n\t.st25{fill:url(#SVGID_21_);}\r\n\t.st26{opacity:0.76;}\r\n\t.st27{fill:url(#SVGID_22_);}\r\n\t.st28{fill:url(#SVGID_23_);}\r\n\t.st29{fill:url(#SVGID_24_);}\r\n\t.st30{opacity:0.78;fill:#FFFFFF;}\r\n\t.st31{fill:url(#SVGID_25_);}\r\n\t.st32{fill:url(#SVGID_26_);}\r\n\t.st33{fill:url(#SVGID_27_);}\r\n\t.st34{fill:url(#SVGID_28_);}\r\n\t.st35{fill:url(#SVGID_29_);}\r\n\t.st36{fill:url(#SVGID_30_);}\r\n\t.st37{fill:url(#SVGID_31_);}\r\n\t.st38{fill:url(#SVGID_32_);}\r\n\t.st39{fill:url(#SVGID_33_);}\r\n\t.st40{fill:url(#SVGID_34_);}\r\n\t.st41{fill:url(#SVGID_35_);}\r\n\t.st42{fill:url(#SVGID_36_);}\r\n\t.st43{fill:url(#SVGID_37_);}\r\n\t.st44{fill:url(#SVGID_38_);}\r\n\t.st45{fill:url(#SVGID_39_);}\r\n\t.st46{fill:url(#SVGID_40_);}\r\n\t.st47{fill:url(#SVGID_41_);}\r\n\t.st48{fill:url(#SVGID_42_);}\r\n\t.st49{fill:url(#SVGID_43_);}\r\n\t.st50{fill:url(#SVGID_44_);}\r\n\t.st51{fill:url(#SVGID_45_);}\r\n\t.st52{fill:url(#SVGID_46_);}\r\n\t.st53{fill:url(#SVGID_47_);}\r\n\t.st54{fill:url(#SVGID_48_);}\r\n\t.st55{fill:url(#SVGID_49_);}\r\n\t.st56{fill:url(#SVGID_50_);}\r\n\t.st57{fill:url(#SVGID_51_);}\r\n\t.st58{fill:url(#SVGID_52_);}\r\n\t.st59{fill:url(#SVGID_53_);}\r\n\t.st60{fill:url(#SVGID_54_);}\r\n\t.st61{fill:url(#SVGID_55_);}\r\n\t.st62{fill:url(#SVGID_56_);}\r\n\t.st63{fill:url(#SVGID_57_);}\r\n\t.st64{opacity:0.5;fill:url(#SVGID_58_);}\r\n\t.st65{fill:url(#SVGID_59_);}\r\n\t.st66{fill:url(#SVGID_60_);}\r\n\t.st67{fill:url(#SVGID_61_);}\r\n\t.st68{fill:url(#SVGID_62_);}\r\n\t.st69{fill:url(#SVGID_63_);}\r\n\t.st70{fill:url(#SVGID_64_);}\r\n\t.st71{fill:url(#SVGID_65_);}\r\n\t.st72{fill:url(#SVGID_66_);}\r\n\t.st73{fill:url(#SVGID_67_);}\r\n\t.st74{fill:url(#SVGID_68_);}\r\n\t.st75{fill:url(#SVGID_69_);}\r\n\t.st76{fill:url(#SVGID_70_);}\r\n\t.st77{fill:url(#SVGID_71_);}\r\n\t.st78{fill:url(#SVGID_72_);}\r\n\t.st79{fill:url(#SVGID_73_);}\r\n\t.st80{fill:url(#SVGID_74_);}\r\n\t.st81{fill:url(#SVGID_75_);}\r\n\t.st82{fill:url(#SVGID_76_);}\r\n\t.st83{fill:url(#SVGID_77_);}\r\n\t.st84{fill:url(#SVGID_78_);}\r\n\t.st85{fill:url(#SVGID_79_);}\r\n\t.st86{fill:url(#SVGID_80_);}\r\n\t.st87{fill:url(#SVGID_81_);}\r\n\t.st88{fill:url(#SVGID_82_);}\r\n\t.st89{fill:url(#SVGID_83_);}\r\n\t.st90{fill:url(#SVGID_84_);}\r\n\t.st91{fill:url(#SVGID_85_);}\r\n\t.st92{fill:url(#SVGID_86_);}\r\n\t.st93{fill:url(#SVGID_87_);}\r\n\t.st94{fill:url(#SVGID_88_);}\r\n\t.st95{fill:url(#SVGID_89_);}\r\n\t.st96{fill:url(#SVGID_90_);}\r\n\t.st97{fill:url(#SVGID_91_);}\r\n\t.st98{fill:url(#SVGID_92_);}\r\n\t.st99{fill:url(#SVGID_93_);}\r\n\t.st100{fill:url(#SVGID_94_);}\r\n\t.st101{fill:url(#SVGID_95_);}\r\n\t.st102{fill:url(#SVGID_96_);}\r\n\t.st103{fill:url(#SVGID_97_);}\r\n\t.st104{fill:url(#SVGID_98_);}\r\n\t.st105{fill:url(#SVGID_99_);}\r\n\t.st106{fill:url(#SVGID_100_);}\r\n\t.st107{fill:#CB96C3;}\r\n\t.st108{fill:url(#SVGID_101_);}\r\n\t.st109{fill:url(#SVGID_102_);}\r\n\t.st110{fill:url(#SVGID_103_);}\r\n\t.st111{fill:url(#SVGID_104_);}\r\n\t.st112{fill:url(#SVGID_105_);}\r\n\t.st113{fill:url(#SVGID_106_);}\r\n\t.st114{fill:url(#SVGID_107_);}\r\n\t.st115{fill:url(#SVGID_108_);}\r\n\t.st116{fill:url(#SVGID_109_);}\r\n\t.st117{fill:url(#SVGID_110_);}\r\n\t.st118{fill:url(#SVGID_111_);}\r\n\t.st119{fill:url(#SVGID_112_);}\r\n\t.st120{fill:url(#SVGID_113_);}\r\n\t.st121{fill:url(#SVGID_114_);}\r\n\t.st122{fill:url(#SVGID_115_);}\r\n\t.st123{fill:url(#SVGID_116_);}\r\n\t.st124{fill:url(#SVGID_117_);}\r\n\t.st125{fill:url(#SVGID_118_);}\r\n\t.st126{fill:url(#SVGID_119_);}\r\n\t.st127{fill:url(#SVGID_120_);}\r\n\t.st128{opacity:0.53;fill:#FFFFFF;}\r\n\t.st129{fill:url(#SVGID_121_);}\r\n\t.st130{opacity:0.75;fill:#FBE0E5;}\r\n\t.st131{fill:#ECD2D8;}\r\n\t.st132{fill:none;stroke:#E1BFC8;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st133{fill:none;stroke:#E1BFC8;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,3.9583;}\r\n\t.st134{fill:none;stroke:#E1BFC8;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,3.9765;}\r\n\t.st135{fill:#324D9C;}\r\n\t.st136{fill:#1D3D91;}\r\n\t.st137{fill:#F6DADD;}\r\n\t.st138{fill:#E9C7CB;}\r\n\t.st139{fill:#D48A0A;}\r\n\t.st140{fill:#F2927C;}\r\n\t.st141{fill:#EB836C;}\r\n\t.st142{fill:#F4F2F1;}\r\n\t.st143{fill:#FBB916;}\r\n\t.st144{fill:#F6A318;}\r\n\t.st145{fill:#FEC708;}\r\n\t.st146{fill:#F5B301;}\r\n\t.st147{fill:#232020;}\r\n\t.st148{fill:#020203;}\r\n\t.st149{fill:#3C73B9;}\r\n\t.st150{fill:#366BB3;}\r\n\t.st151{fill:#FFD504;}\r\n\t.st152{fill:#FBB911;}\r\n\t.st153{fill:#FFDB2A;}\r\n\t.st154{fill:#E8F2FA;}\r\n\t.st155{fill:#C9DEF4;}\r\n\t.st156{fill:#DDE9F8;}\r\n\t.st157{fill:#F28F35;}\r\n\t.st158{fill:#ACC0E4;}\r\n\t.st159{fill:#FFF7EF;}\r\n\t.st160{fill:#FDDCC3;}\r\n\t.st161{fill:#F7AD76;}\r\n\t.st162{fill:#1F3865;}\r\n\t.st163{fill:#264790;}\r\n\t.st164{fill:#F39153;}\r\n\t.st165{fill:#91B0DD;}\r\n\t.st166{fill:#EE751B;}\r\n\t.st167{fill:#20396F;}\r\n\t.st168{fill:#EEC09D;}\r\n\t.st169{fill:#EF7A3E;}\r\n\t.st170{fill:#6896CF;}\r\n\t.st171{fill:#4880C1;}\r\n\t.st172{fill:#FDDBBA;}\r\n\t.st173{fill:#144179;}\r\n\t.st174{fill:#EE761C;}\r\n\t.st175{fill:#F39254;}\r\n\t.st176{fill:#2A3967;}\r\n\t.st177{fill:#ACCAEB;}\r\n\t.st178{fill:#EA5A21;}\r\n\t.st179{fill:#F07F26;}\r\n\t.st180{fill:#9FC6EA;}\r\n\t.st181{fill:#E0EFFB;}\r\n\t.st182{fill:#183F73;}\r\n\t.st183{fill:#F59E60;}\r\n\t.st184{fill:#1A3760;}\r\n\t.st185{fill:#0F4E88;}\r\n\t.st186{fill:#AFCCED;}\r\n\t.st187{fill:#2D3555;}\r\n\t.st188{opacity:0.7;}\r\n\t.st189{opacity:0.5;fill:url(#SVGID_122_);}\r\n\t.st190{opacity:0.5;fill:url(#SVGID_123_);}\r\n\t.st191{opacity:0.65;fill:#FFFFFF;}\r\n\t.st192{fill:url(#SVGID_124_);}\r\n\t.st193{opacity:0.57;fill:#FFFFFF;}\r\n\t.st194{fill:url(#SVGID_125_);}\r\n\t.st195{fill:url(#SVGID_126_);}\r\n\t.st196{opacity:0.5;fill:#FFFFFF;}\r\n\t.st197{fill:url(#SVGID_127_);}\r\n\t.st198{fill:url(#SVGID_128_);}\r\n\t.st199{fill:url(#SVGID_129_);}\r\n\t.st200{fill:url(#SVGID_130_);}\r\n\t.st201{fill:url(#SVGID_131_);}\r\n\t.st202{fill:url(#SVGID_132_);}\r\n\t.st203{fill:url(#SVGID_133_);}\r\n\t.st204{fill:url(#SVGID_134_);}\r\n\t.st205{fill:url(#SVGID_135_);}\r\n\t.st206{fill:url(#SVGID_136_);}\r\n\t.st207{opacity:0.69;fill:#FFFFFF;}\r\n\t.st208{fill:url(#SVGID_137_);}\r\n\t.st209{fill:url(#SVGID_138_);}\r\n\t.st210{fill:url(#SVGID_139_);}\r\n\t.st211{fill:url(#SVGID_140_);}\r\n\t.st212{fill:url(#SVGID_141_);}\r\n\t.st213{fill:url(#SVGID_142_);}\r\n\t.st214{fill:url(#SVGID_143_);}\r\n\t.st215{fill:url(#SVGID_144_);}\r\n\t.st216{fill:url(#SVGID_145_);}\r\n\t.st217{fill:url(#SVGID_146_);}\r\n\t.st218{fill:url(#SVGID_147_);}\r\n\t.st219{fill:url(#SVGID_148_);}\r\n\t.st220{fill:url(#SVGID_149_);}\r\n\t.st221{fill:url(#SVGID_150_);}\r\n\t.st222{fill:url(#SVGID_151_);}\r\n\t.st223{opacity:0.72;fill:#FFFFFF;}\r\n\t.st224{fill:url(#SVGID_152_);}\r\n\t.st225{fill:url(#SVGID_153_);}\r\n\t.st226{fill:url(#SVGID_154_);}\r\n\t.st227{fill:url(#SVGID_155_);}\r\n\t.st228{fill:url(#SVGID_156_);}\r\n\t.st229{fill:url(#SVGID_157_);}\r\n\t.st230{fill:url(#SVGID_158_);}\r\n\t.st231{fill:url(#SVGID_159_);}\r\n\t.st232{fill:url(#SVGID_160_);}\r\n\t.st233{fill:url(#SVGID_161_);}\r\n\t.st234{fill:url(#SVGID_162_);}\r\n\t.st235{fill:url(#SVGID_163_);}\r\n\t.st236{fill:url(#SVGID_164_);}\r\n\t.st237{fill:url(#SVGID_165_);}\r\n\t.st238{fill:url(#SVGID_166_);}\r\n\t.st239{fill:url(#SVGID_167_);}\r\n\t.st240{fill:url(#SVGID_168_);}\r\n\t.st241{fill:url(#SVGID_169_);}\r\n\t.st242{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_170_);}\r\n\t.st243{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_171_);}\r\n\t.st244{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_172_);}\r\n\t.st245{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_173_);}\r\n\t.st246{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_174_);}\r\n\t.st247{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_175_);}\r\n\t.st248{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_176_);}\r\n\t.st249{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_177_);}\r\n\t.st250{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_178_);}\r\n\t.st251{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_179_);}\r\n\t.st252{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_180_);}\r\n\t.st253{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_181_);}\r\n\t.st254{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_182_);}\r\n\t.st255{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_183_);}\r\n\t.st256{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_184_);}\r\n\t.st257{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_185_);}\r\n\t.st258{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_186_);}\r\n\t.st259{fill:url(#SVGID_187_);}\r\n\t.st260{fill:url(#SVGID_188_);}\r\n\t.st261{fill:url(#SVGID_189_);}\r\n\t.st262{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_190_);}\r\n\t.st263{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_191_);}\r\n\t.st264{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_192_);}\r\n\t.st265{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_193_);}\r\n\t.st266{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_194_);}\r\n\t.st267{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_195_);}\r\n\t.st268{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_196_);}\r\n\t.st269{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_197_);}\r\n\t.st270{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_198_);}\r\n\t.st271{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_199_);}\r\n\t.st272{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_200_);}\r\n\t.st273{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_201_);}\r\n\t.st274{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_202_);}\r\n\t.st275{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_203_);}\r\n\t.st276{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_204_);}\r\n\t.st277{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_205_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -4290.2017,
    y1: -997.9221,
    x2: -4333.647,
    y2: -869.0439,
    gradientTransform: "matrix(0.9968 0.0802 -0.0802 0.9968 4374.9917 1387.3842)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.55,68.17c0.37-4.66-3.1-8.73-7.75-9.11c-4.66-0.37-8.73,3.1-9.11,7.75c0,0,0,0,0,0 c-0.21,2.59-1.52,4.96-3.59,6.52c-2.39,1.79-4.02,4.56-4.28,7.77c0,0,0,0,0,0c-0.25,3.13-1.95,5.97-4.58,7.68 c-3.08,2-5.24,5.36-5.56,9.3c-0.54,6.74,4.48,12.65,11.23,13.19c6.74,0.54,12.65-4.48,13.19-11.23c0.03-0.36,0.04-0.72,0.04-1.07 c-0.02-3.48,1.39-6.81,3.9-9.21c1.84-1.76,3.07-4.18,3.29-6.93c0.1-1.21-0.01-2.38-0.29-3.49c-0.56-2.23,0-4.59,1.5-6.34 C178.67,71.69,179.4,70.03,179.55,68.17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.33,106.49c-0.03,0-0.07-0.01-0.1-0.03c-0.08-0.05-0.1-0.16-0.04-0.24 c13.78-19.91,19.13-38.36,19.19-38.54c0.03-0.09,0.12-0.14,0.21-0.12c0.09,0.03,0.14,0.12,0.12,0.21 c-0.05,0.18-5.42,18.69-19.24,38.64C152.44,106.47,152.39,106.49,152.33,106.49z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M168.85,75.26c-0.04,0-0.08-0.01-0.11-0.04c-1.94-1.68-2.95-6.98-2.99-7.21c-0.02-0.09,0.04-0.18,0.14-0.2 c0.09-0.02,0.18,0.04,0.2,0.14c0.01,0.05,1.04,5.41,2.88,7.01c0.07,0.06,0.08,0.17,0.02,0.24 C168.95,75.24,168.9,75.26,168.85,75.26z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M169.02,75.27c-0.07,0-0.14-0.05-0.16-0.13c-0.02-0.09,0.03-0.18,0.12-0.21c0.04-0.01,3.56-0.99,5.74-2.93 c0.07-0.06,0.18-0.06,0.24,0.01c0.06,0.07,0.06,0.18-0.01,0.24c-2.24,1.99-5.73,2.97-5.88,3.01 C169.05,75.27,169.03,75.27,169.02,75.27z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M163.7,86.93c-0.05,0-0.1-0.02-0.13-0.06c-2.62-3.19-3.01-8.47-3.02-8.53c-0.01-0.09,0.06-0.18,0.16-0.18 c0.09-0.01,0.18,0.06,0.18,0.16c0,0.05,0.39,5.23,2.94,8.33c0.06,0.07,0.05,0.18-0.02,0.24 C163.78,86.92,163.74,86.93,163.7,86.93z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M163.95,87.02c-0.11,0-0.17,0-0.19,0c-0.09-0.01-0.17-0.09-0.16-0.18c0.01-0.09,0.09-0.17,0.18-0.16 c0.04,0,3.82,0.17,7.84-3.11c0.07-0.06,0.18-0.05,0.24,0.02c0.06,0.07,0.05,0.18-0.02,0.24 C168.17,86.83,164.78,87.02,163.95,87.02z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.83,100.79c-0.33,0-0.52-0.01-0.53-0.01c-0.09-0.01-0.16-0.09-0.16-0.18c0.01-0.09,0.09-0.16,0.18-0.16 c0.04,0,4.48,0.32,8.27-2.32c0.08-0.05,0.18-0.03,0.24,0.04c0.05,0.08,0.04,0.18-0.04,0.24 C161.69,100.57,158.15,100.79,156.83,100.79z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.18,100.71c-0.04,0-0.09-0.02-0.12-0.05c-0.11-0.11-2.73-2.88-2.89-8.19c0-0.09,0.07-0.17,0.17-0.18 c0.1,0,0.17,0.07,0.18,0.17c0.15,5.18,2.77,7.94,2.8,7.96c0.07,0.07,0.06,0.18,0,0.24C156.26,100.7,156.22,100.71,156.18,100.71z "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -32.9468,
    y1: -112.5362,
    x2: 9.3144,
    y2: -133.0265,
    gradientTransform: "matrix(0.987 0.1606 -0.1606 0.987 170.1389 190.4353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C4997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA4B7B"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150.27,45.86c4.18-4.28,11.04-4.37,15.32-0.19c4.28,4.18,4.37,11.04,0.19,15.32c0,0,0,0,0,0 c-2.32,2.38-3.51,5.65-3.26,8.96c0.28,3.81-1.01,7.72-3.89,10.68c0,0,0,0,0,0c-2.81,2.88-4.12,6.91-3.54,10.89 c0.67,4.66-0.75,9.57-4.29,13.2c-6.05,6.21-15.98,6.33-22.19,0.28c-6.21-6.05-6.33-15.98-0.28-22.19c0.32-0.33,0.66-0.65,1-0.94 c3.37-2.91,5.4-7.08,5.6-11.53c0.15-3.27,1.45-6.49,3.91-9.02c1.08-1.11,2.3-2,3.61-2.67c2.62-1.34,4.43-3.87,4.85-6.79 C147.62,49.68,148.6,47.57,150.27,45.86z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.39,104.46c-0.01,0-0.03,0-0.04-0.01c-0.09-0.02-0.15-0.12-0.12-0.21 c7.62-30.14,20.95-50.91,21.08-51.12c0.05-0.08,0.16-0.1,0.24-0.05c0.08,0.05,0.1,0.16,0.05,0.24 c-0.13,0.21-13.43,20.93-21.04,51.02C136.53,104.4,136.46,104.46,136.39,104.46z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M153.2,62.22c-0.22,0-0.42-0.01-0.62-0.04c-0.09-0.01-0.16-0.1-0.15-0.19c0.01-0.09,0.1-0.16,0.19-0.15 c3.12,0.43,9.17-3.1,9.23-3.13c0.08-0.05,0.19-0.02,0.23,0.06c0.05,0.08,0.02,0.19-0.06,0.23c-0.02,0.01-1.56,0.91-3.48,1.75 C156.33,61.73,154.53,62.22,153.2,62.22z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.46,62.03c-0.06,0-0.12-0.04-0.15-0.1c-0.02-0.04-2.08-4.35-2.05-8.19c0-0.09,0.08-0.17,0.17-0.17 c0,0,0,0,0,0c0.09,0,0.17,0.08,0.17,0.17c-0.03,3.76,1.99,7.99,2.01,8.03c0.04,0.08,0.01,0.19-0.08,0.23 C152.51,62.03,152.48,62.03,152.46,62.03z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M145.69,76.99c-0.09,0-0.17-0.07-0.17-0.17c0-0.09,0.07-0.17,0.17-0.18c5.17-0.15,10.5-4.16,10.55-4.2 c0.08-0.06,0.18-0.04,0.24,0.03c0.06,0.08,0.04,0.18-0.03,0.24C156.39,72.77,150.97,76.84,145.69,76.99 C145.69,76.99,145.69,76.99,145.69,76.99z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M145.55,77.01c-0.04,0-0.09-0.02-0.12-0.05c-0.03-0.04-3.49-3.64-3.72-10.44c0-0.09,0.07-0.17,0.17-0.18 c0,0,0,0,0.01,0c0.09,0,0.17,0.07,0.17,0.17c0.11,3.48,1.09,6.07,1.89,7.63c0.87,1.69,1.72,2.57,1.73,2.58 c0.07,0.07,0.06,0.18,0,0.24C145.63,76.99,145.59,77.01,145.55,77.01z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M138.55,95.79c-0.04,0-0.09-0.02-0.12-0.05c-0.04-0.04-4.19-4.15-4.85-10.17c-0.01-0.09,0.06-0.18,0.15-0.19 c0.09-0.01,0.18,0.06,0.19,0.15c0.64,5.9,4.7,9.92,4.74,9.96c0.07,0.07,0.07,0.17,0,0.24C138.64,95.77,138.59,95.79,138.55,95.79 z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M138.86,95.87c-0.09,0-0.14,0-0.14,0c-0.09,0-0.17-0.09-0.16-0.18c0-0.09,0.08-0.16,0.18-0.16 c0.05,0,4.94,0.2,10.08-4.02c0.07-0.06,0.18-0.05,0.24,0.02c0.06,0.07,0.05,0.18-0.02,0.24 C144.27,95.68,139.71,95.87,138.86,95.87z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -6714.7544,
    y1: -729.8193,
    x2: -6758.1992,
    y2: -600.9435,
    gradientTransform: "matrix(-0.9928 0.1201 0.1201 0.9928 -6566.1885 1577.5554)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C4997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA4B7B"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.35,66.17c-0.56-4.64,2.74-8.85,7.38-9.41c4.64-0.56,8.85,2.74,9.41,7.38c0,0,0,0,0,0 c0.31,2.58,1.72,4.9,3.85,6.37c2.46,1.69,4.2,4.39,4.59,7.59c0,0,0,0,0,0c0.38,3.12,2.19,5.88,4.89,7.49 c3.16,1.87,5.45,5.14,5.93,9.07c0.81,6.71-3.97,12.82-10.69,13.63c-6.71,0.81-12.82-3.97-13.63-10.69 c-0.04-0.36-0.07-0.72-0.08-1.07c-0.12-3.47-1.66-6.75-4.27-9.05c-1.91-1.69-3.24-4.06-3.57-6.79c-0.15-1.2-0.09-2.38,0.15-3.5 c0.47-2.25-0.19-4.59-1.75-6.27C13.38,69.65,12.57,68.01,12.35,66.17z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.08,103.36c-0.05,0-0.1-0.02-0.14-0.07C26.34,83.91,20.24,65.64,20.18,65.46 c-0.03-0.09,0.02-0.19,0.11-0.22c0.09-0.03,0.19,0.02,0.22,0.11c0.06,0.18,6.15,18.4,20.72,37.74c0.06,0.08,0.04,0.18-0.03,0.24 C41.16,103.35,41.12,103.36,41.08,103.36z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.32,72.82c-0.05,0-0.09-0.02-0.12-0.05c-0.06-0.07-0.06-0.18,0.01-0.24c1.78-1.68,2.59-7.07,2.6-7.12 c0.01-0.09,0.1-0.16,0.19-0.14c0.09,0.01,0.16,0.1,0.14,0.19c-0.03,0.23-0.84,5.56-2.7,7.32C23.4,72.8,23.36,72.82,23.32,72.82z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.15,72.84c-0.01,0-0.03,0-0.04,0c-0.15-0.03-3.67-0.87-5.99-2.77c-0.07-0.06-0.08-0.17-0.02-0.24 c0.06-0.07,0.17-0.08,0.24-0.02c2.26,1.85,5.82,2.69,5.85,2.7c0.09,0.02,0.15,0.11,0.13,0.2C23.3,72.78,23.23,72.84,23.15,72.84z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.94,84.27c-0.04,0-0.07-0.01-0.1-0.03c-0.08-0.06-0.09-0.16-0.03-0.24c2.43-3.2,2.6-8.39,2.6-8.45 c0-0.09,0.08-0.17,0.18-0.17c0.09,0,0.17,0.08,0.17,0.18c0,0.05-0.18,5.35-2.67,8.64C29.04,84.25,28.99,84.27,28.94,84.27z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.45,84.38c-1.13,0-4.28-0.26-7.75-2.87c-0.08-0.06-0.09-0.16-0.03-0.24c0.06-0.08,0.16-0.09,0.24-0.03 c4.14,3.12,7.92,2.79,7.95,2.79c0.09-0.01,0.18,0.06,0.19,0.15c0.01,0.09-0.06,0.18-0.15,0.19 C28.86,84.37,28.71,84.38,28.45,84.38z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.84,97.85c-1.58,0-4.69-0.27-7.53-2.08c-0.08-0.05-0.1-0.16-0.05-0.24c0.05-0.08,0.16-0.1,0.24-0.05 c3.89,2.49,8.31,1.99,8.36,1.98c0.09-0.01,0.18,0.06,0.19,0.15c0.01,0.09-0.06,0.18-0.15,0.19 C36.88,97.81,36.49,97.85,35.84,97.85z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.01,97.74c-0.04,0-0.08-0.01-0.11-0.04c-0.07-0.06-0.08-0.17-0.01-0.24c0.03-0.03,2.53-2.89,2.47-8.07 c0-0.09,0.07-0.17,0.17-0.17c0,0,0,0,0,0c0.09,0,0.17,0.08,0.17,0.17c0.06,5.32-2.45,8.18-2.56,8.3 C37.1,97.72,37.05,97.74,37.01,97.74z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -6895.5894,
    y1: 193.1669,
    x2: -6930.9341,
    y2: 298.0151,
    gradientTransform: "matrix(-0.8515 0.5244 0.5244 0.8515 -5975.0166 3526.6602)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M4.39,89.66c-1.99-3.24-0.98-7.47,2.25-9.47c3.24-1.99,7.47-0.98,9.47,2.25c0,0,0,0,0,0 c1.11,1.8,2.93,3.03,5.01,3.4c2.39,0.41,4.6,1.81,5.97,4.04c0,0,0,0,0,0c1.34,2.18,3.62,3.6,6.16,3.87 c2.97,0.31,5.78,1.94,7.47,4.69c2.89,4.69,1.43,10.82-3.26,13.71c-4.69,2.89-10.82,1.43-13.71-3.26 c-0.15-0.25-0.3-0.51-0.43-0.76c-1.27-2.53-3.52-4.42-6.23-5.23c-1.99-0.6-3.77-1.9-4.95-3.8c-0.52-0.84-0.87-1.73-1.08-2.64 c-0.42-1.82-1.7-3.33-3.43-4.04C6.33,91.89,5.18,90.95,4.39,89.66z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.22,107.42c-0.03,0-0.06-0.01-0.08-0.02C20.75,98.04,10.01,86.61,9.91,86.5 c-0.06-0.07-0.06-0.18,0.01-0.24c0.07-0.06,0.18-0.06,0.24,0.01c0.11,0.11,10.81,11.5,28.15,20.83c0.08,0.04,0.11,0.15,0.07,0.23 C38.34,107.39,38.28,107.42,38.22,107.42z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.7,90.89c-0.02,0-0.04,0-0.06-0.01c-0.09-0.04-0.13-0.13-0.09-0.22c0.74-1.84-0.49-6.08-0.5-6.13 c-0.03-0.09,0.03-0.19,0.12-0.21c0.09-0.03,0.19,0.03,0.21,0.12c0.05,0.18,1.28,4.4,0.49,6.35 C14.83,90.85,14.77,90.89,14.7,90.89z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.72,91.23c-0.8,0-1.68-0.07-2.49-0.28c-0.09-0.02-0.15-0.12-0.12-0.21c0.02-0.09,0.12-0.15,0.21-0.12 c2.29,0.6,5.2,0.01,5.23,0c0.09-0.02,0.18,0.04,0.2,0.13c0.02,0.09-0.04,0.18-0.13,0.2C14.54,90.97,13.26,91.23,11.72,91.23z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.75,97.44c-0.01,0-0.02,0-0.04,0c-0.09-0.02-0.15-0.11-0.13-0.2c0.7-3.18-0.93-7.07-0.95-7.11 c-0.04-0.09,0-0.19,0.09-0.22c0.09-0.04,0.19,0,0.22,0.09c0.07,0.16,1.69,4.02,0.97,7.31C22.9,97.39,22.83,97.44,22.75,97.44z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.44,98.48c-0.8,0-1.69-0.08-2.67-0.29c-0.09-0.02-0.15-0.11-0.13-0.2c0.02-0.09,0.11-0.15,0.2-0.13 c4.12,0.89,6.78-0.63,6.8-0.64c0.08-0.05,0.19-0.02,0.23,0.06c0.05,0.08,0.02,0.19-0.06,0.23 C22.74,97.56,21.12,98.48,18.44,98.48z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.61,106.23c-0.44,0-0.89-0.03-1.36-0.09c-0.09-0.01-0.16-0.1-0.15-0.19c0.01-0.09,0.1-0.16,0.19-0.15 c3.71,0.51,6.8-1.35,6.83-1.37c0.08-0.05,0.19-0.02,0.23,0.06c0.05,0.08,0.02,0.19-0.06,0.23 C33.28,104.74,30.81,106.23,27.61,106.23z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.3,104.65c-0.02,0-0.03,0-0.05-0.01c-0.09-0.03-0.14-0.12-0.11-0.21c0.01-0.03,0.88-2.99-0.92-6.78 c-0.04-0.09,0-0.19,0.08-0.23c0.09-0.04,0.19,0,0.23,0.08c1.86,3.92,0.97,6.9,0.93,7.03C33.44,104.6,33.37,104.65,33.3,104.65z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.792,
    y1: 77.6991,
    x2: 62.3913,
    y2: 41.5849
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C4997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA4B7B"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M54.99,44.97c-2.6-5.39-9.08-7.65-14.47-5.05c-5.39,2.6-7.65,9.08-5.05,14.47c0,0,0,0,0,0 c1.45,3,1.54,6.47,0.25,9.54c-1.48,3.53-1.5,7.64,0.29,11.36c0,0,0,0,0,0c1.75,3.63,1.71,7.86-0.1,11.46 c-2.12,4.21-2.32,9.31-0.12,13.88c3.77,7.8,13.15,11.08,20.95,7.31c7.8-3.77,11.08-13.15,7.31-20.95 c-0.2-0.42-0.42-0.82-0.65-1.21c-2.28-3.83-2.87-8.43-1.65-12.71c0.9-3.14,0.69-6.61-0.85-9.79c-0.67-1.4-1.55-2.63-2.58-3.67 c-2.06-2.1-2.97-5.08-2.45-7.98C56.29,49.43,56.03,47.11,54.99,44.97z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.6,104.95c0,0-0.01,0-0.01,0c-0.09-0.01-0.16-0.09-0.16-0.18c2.34-30.94-3.69-54.82-3.75-55.06 c-0.02-0.09,0.03-0.18,0.12-0.21c0.09-0.02,0.18,0.03,0.21,0.12c0.06,0.24,6.11,24.16,3.76,55.17 C49.77,104.88,49.69,104.95,49.6,104.95z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.64,59.71c-0.01,0-0.02,0-0.03,0c-1.36-0.26-3.11-1.35-5.21-3.25c-1.55-1.41-2.73-2.75-2.74-2.77 c-0.06-0.07-0.05-0.18,0.02-0.24c0.07-0.06,0.18-0.05,0.24,0.02c0.05,0.05,4.66,5.32,7.76,5.9c0.09,0.02,0.15,0.11,0.14,0.2 C47.79,59.65,47.72,59.71,47.64,59.71z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.83,59.62c-0.04,0-0.09-0.02-0.12-0.05c-0.07-0.07-0.07-0.17,0-0.24c0.03-0.03,3.3-3.41,4.46-6.98 c0.03-0.09,0.13-0.14,0.22-0.11c0.09,0.03,0.14,0.13,0.11,0.22c-1.19,3.65-4.51,7.08-4.54,7.11 C47.92,59.6,47.87,59.62,47.83,59.62z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.5,75.95c-0.02,0-0.04,0-0.06-0.01c-4.95-1.82-8.8-7.4-8.84-7.46c-0.05-0.08-0.03-0.18,0.04-0.24 c0.08-0.05,0.18-0.03,0.24,0.04c0.04,0.06,3.82,5.54,8.67,7.33c0.09,0.03,0.13,0.13,0.1,0.22C49.63,75.91,49.57,75.95,49.5,75.95 z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.63,76.01c-0.06,0-0.12-0.03-0.15-0.09c-0.04-0.08-0.01-0.19,0.07-0.23c0.04-0.02,4.35-2.29,6.67-8.54 c0.03-0.09,0.13-0.13,0.22-0.1c0.09,0.03,0.13,0.13,0.1,0.22c-2.37,6.38-6.79,8.7-6.84,8.72C49.68,76,49.66,76.01,49.63,76.01z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.31,96.04c-0.06,0-0.12-0.04-0.15-0.1c-0.04-0.08-0.01-0.19,0.08-0.23c0.05-0.02,5.18-2.55,7.66-7.94 c0.04-0.09,0.14-0.12,0.23-0.08c0.09,0.04,0.12,0.14,0.08,0.23c-2.53,5.5-7.77,8.08-7.82,8.11 C50.36,96.03,50.33,96.04,50.31,96.04z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.11,96.06c-0.02,0-0.03,0-0.05-0.01c-0.05-0.01-4.87-1.4-8.48-7.16c-0.05-0.08-0.03-0.19,0.05-0.24 c0.08-0.05,0.19-0.03,0.24,0.05c3.54,5.65,8.23,7,8.28,7.02c0.09,0.03,0.14,0.12,0.12,0.21C50.25,96.01,50.19,96.06,50.11,96.06z "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 9198.8428,
    y1: 83.8647,
    x2: 9153.6211,
    y2: 113.1794,
    gradientTransform: "matrix(-1 0 0 1 9258.7656 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M42.32,93.2l48.9,0v-9.79l-48.9,0C43.36,83.41,43.36,93.2,42.32,93.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.996,
    y1: 88.2464,
    x2: 44.8901,
    y2: 88.6003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M91.22,90.75v-4.48c0-1.58-0.97-2.86-2.16-2.86H42.52c-0.94,0-1.7-0.76-1.7-1.7l0,0 c0-0.28,0.23-0.52,0.52-0.52H92.2c1.17,0,3.02,1.83,3.02,4.1v6.26c0,2.13-1.8,3.86-2.9,3.86H41.61c-0.43,0-0.78-0.35-0.78-0.78 l0,0c0-0.79,0.64-1.43,1.43-1.43h47.11C90.39,93.2,91.22,92.1,91.22,90.75z"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.86,85.59H44.01c-0.09,0-0.17-0.08-0.17-0.17c0-0.09,0.08-0.17,0.17-0.17h45.85 c0.09,0,0.17,0.08,0.17,0.17C90.04,85.51,89.96,85.59,89.86,85.59z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.86,87.04H44.01c-0.09,0-0.17-0.08-0.17-0.17c0-0.09,0.08-0.17,0.17-0.17h45.85 c0.09,0,0.17,0.08,0.17,0.17C90.04,86.96,89.96,87.04,89.86,87.04z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.86,88.49H44.01c-0.09,0-0.17-0.08-0.17-0.17c0-0.09,0.08-0.17,0.17-0.17h45.85 c0.09,0,0.17,0.08,0.17,0.17C90.04,88.42,89.96,88.49,89.86,88.49z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.86,89.95H44.01c-0.09,0-0.17-0.08-0.17-0.17c0-0.09,0.08-0.17,0.17-0.17h45.85 c0.09,0,0.17,0.08,0.17,0.17C90.04,89.87,89.96,89.95,89.86,89.95z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.86,91.4H44.01c-0.09,0-0.17-0.08-0.17-0.17c0-0.09,0.08-0.17,0.17-0.17h45.85 c0.09,0,0.17,0.08,0.17,0.17C90.04,91.32,89.96,91.4,89.86,91.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.0243,
    y1: 91.9632,
    x2: 91.7074,
    y2: 110.4548
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CC246E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C266C"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M115.3,116.59H34.5c-2.07,0-3.75-1.68-3.75-3.75V99.02c0-2.07,1.68-3.75,3.75-3.75h80.8 c2.07,0,3.75,1.68,3.75,3.75v13.82C119.04,114.91,117.37,116.59,115.3,116.59z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.5699,
    y1: 125.9759,
    x2: 45.9069,
    y2: 105.8367
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M49.28,114.14h-6.73c-1.01,0-1.82-0.82-1.82-1.82V99.55c0-1.01,0.82-1.82,1.82-1.82h6.73 c1.01,0,1.82,0.82,1.82,1.82v12.77C51.11,113.32,50.29,114.14,49.28,114.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.1218,
    y1: 125.1774,
    x2: 54.4168,
    y2: 104.7214
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M55.84,114.14h-2.52c-0.38,0-0.68-0.31-0.68-0.68V98.41c0-0.38,0.31-0.68,0.68-0.68h2.52 c0.38,0,0.68,0.31,0.68,0.68v15.04C56.52,113.83,56.22,114.14,55.84,114.14z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 9114.0625,
    y1: 105.7245,
    x2: 9068.8408,
    y2: 135.0393,
    gradientTransform: "matrix(-1 0 0 1 9258.7656 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M127.1,115.06l48.9,0v-9.79l-48.9,0C128.15,105.27,128.15,115.06,127.1,115.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.6049,
    y1: 86.6027,
    x2: 133.9883,
    y2: 129.6344
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M176,112.61v-4.48c0-1.58-0.97-2.86-2.16-2.86h-46.54c-0.94,0-1.7-0.76-1.7-1.7l0,0 c0-0.28,0.23-0.52,0.52-0.52h50.86c1.17,0,3.02,1.83,3.02,4.1v6.26c0,2.13-1.8,3.86-2.9,3.86h-50.72 c-0.43,0-0.78-0.35-0.78-0.78l0,0c0-0.79,0.64-1.43,1.43-1.43h47.11C175.17,115.06,176,113.96,176,112.61z"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M174.65,107.45h-45.85c-0.09,0-0.17-0.08-0.17-0.17c0-0.09,0.08-0.17,0.17-0.17h45.85 c0.09,0,0.17,0.08,0.17,0.17C174.82,107.37,174.74,107.45,174.65,107.45z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M174.65,108.9h-45.85c-0.09,0-0.17-0.08-0.17-0.17c0-0.09,0.08-0.17,0.17-0.17h45.85 c0.09,0,0.17,0.08,0.17,0.17C174.82,108.82,174.74,108.9,174.65,108.9z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M174.65,110.35h-45.85c-0.09,0-0.17-0.08-0.17-0.17c0-0.09,0.08-0.17,0.17-0.17h45.85 c0.09,0,0.17,0.08,0.17,0.17C174.82,110.28,174.74,110.35,174.65,110.35z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M174.65,111.81h-45.85c-0.09,0-0.17-0.08-0.17-0.17c0-0.09,0.08-0.17,0.17-0.17h45.85 c0.09,0,0.17,0.08,0.17,0.17C174.82,111.73,174.74,111.81,174.65,111.81z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M174.65,113.26h-45.85c-0.09,0-0.17-0.08-0.17-0.17c0-0.09,0.08-0.17,0.17-0.17h45.85 c0.09,0,0.17,0.08,0.17,0.17C174.82,113.18,174.74,113.26,174.65,113.26z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.2281,
    y1: 85.6544,
    x2: 153.7125,
    y2: 106.5379
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M133.8,103.01h40.27c1.03,0,1.87-0.84,1.87-1.87v-6.89c0-1.03-0.84-1.87-1.87-1.87H133.8 c-1.03,0-1.87,0.84-1.87,1.87v6.89C131.93,102.18,132.77,103.01,133.8,103.01z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M166.7,101.79h3.35c0.5,0,0.91-0.41,0.91-0.91v-6.36c0-0.5-0.41-0.91-0.91-0.91h-3.35 c-0.5,0-0.91,0.41-0.91,0.91v6.36C165.79,101.38,166.2,101.79,166.7,101.79z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M163.43,101.79h1.26c0.19,0,0.34-0.15,0.34-0.34v-7.5c0-0.19-0.15-0.34-0.34-0.34h-1.26 c-0.19,0-0.34,0.15-0.34,0.34v7.5C163.09,101.64,163.24,101.79,163.43,101.79z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M157.32,43.54c-0.07,0-0.13-0.04-0.16-0.11c-0.04-0.09,0.01-0.19,0.09-0.22c0.21-0.09,0.41-0.18,0.62-0.27 c0.09-0.04,0.19,0,0.23,0.08c0.04,0.09,0,0.19-0.08,0.23c-0.21,0.1-0.42,0.19-0.63,0.28C157.36,43.54,157.34,43.54,157.32,43.54 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M151.04,44.79c-0.29,0-0.58-0.01-0.86-0.02c-0.09-0.01-0.17-0.09-0.16-0.18c0.01-0.09,0.09-0.17,0.18-0.16 c0.45,0.02,0.91,0.03,1.37,0.01c0,0,0,0,0.01,0c0.09,0,0.17,0.07,0.17,0.17c0,0.09-0.07,0.17-0.17,0.18 C151.4,44.79,151.22,44.79,151.04,44.79z M153.82,44.55c-0.08,0-0.15-0.06-0.17-0.14c-0.02-0.09,0.05-0.18,0.14-0.2 c0.45-0.08,0.9-0.17,1.34-0.29c0.09-0.02,0.18,0.03,0.21,0.12c0.02,0.09-0.03,0.18-0.12,0.21c-0.45,0.12-0.91,0.22-1.37,0.29 C153.84,44.55,153.83,44.55,153.82,44.55z M147.95,44.49c-0.01,0-0.02,0-0.03,0c-0.46-0.09-0.92-0.2-1.36-0.33 c-0.09-0.03-0.14-0.12-0.12-0.21c0.03-0.09,0.12-0.14,0.21-0.12c0.44,0.13,0.89,0.23,1.34,0.32c0.09,0.02,0.15,0.11,0.14,0.2 C148.1,44.44,148.03,44.49,147.95,44.49z M144.48,43.4c-0.02,0-0.05,0-0.07-0.01c-0.43-0.19-0.85-0.4-1.26-0.62 c-0.08-0.05-0.11-0.15-0.07-0.23c0.05-0.08,0.15-0.11,0.23-0.07c0.4,0.22,0.81,0.42,1.23,0.61c0.09,0.04,0.13,0.14,0.09,0.23 C144.61,43.36,144.55,43.4,144.48,43.4z M141.34,41.57c-0.04,0-0.07-0.01-0.1-0.03c-0.37-0.28-0.74-0.58-1.09-0.89 c-0.07-0.06-0.08-0.17-0.01-0.24c0.06-0.07,0.17-0.08,0.24-0.01c0.34,0.3,0.7,0.59,1.07,0.87c0.08,0.06,0.09,0.16,0.03,0.24 C141.44,41.54,141.39,41.57,141.34,41.57z M138.68,39.08c-0.05,0-0.1-0.02-0.13-0.06c-0.3-0.35-0.59-0.73-0.87-1.1 c-0.05-0.08-0.04-0.18,0.04-0.24c0.08-0.06,0.18-0.04,0.24,0.04c0.27,0.37,0.55,0.73,0.85,1.08c0.06,0.07,0.05,0.18-0.02,0.24 C138.76,39.07,138.72,39.08,138.68,39.08z M136.64,36.07c-0.06,0-0.12-0.03-0.15-0.09c-0.22-0.41-0.42-0.84-0.6-1.27 c-0.04-0.09,0-0.19,0.09-0.22c0.09-0.04,0.19,0,0.22,0.09c0.18,0.42,0.37,0.84,0.59,1.24c0.04,0.08,0.01,0.19-0.07,0.23 C136.7,36.06,136.67,36.07,136.64,36.07z M135.33,32.68c-0.08,0-0.14-0.05-0.17-0.13c-0.12-0.45-0.22-0.91-0.3-1.37 c-0.02-0.09,0.05-0.18,0.14-0.2c0.09-0.02,0.18,0.05,0.2,0.14c0.08,0.45,0.18,0.9,0.29,1.34c0.02,0.09-0.03,0.18-0.12,0.21 C135.35,32.68,135.34,32.68,135.33,32.68z M134.8,29.08c-0.09,0-0.17-0.07-0.17-0.16c-0.01-0.2-0.01-0.4-0.01-0.59 c0-0.27,0.01-0.54,0.02-0.81c0-0.09,0.08-0.17,0.18-0.16c0.09,0,0.17,0.08,0.16,0.18c-0.01,0.26-0.02,0.53-0.02,0.79 c0,0.19,0,0.39,0.01,0.58C134.97,29,134.9,29.08,134.8,29.08C134.8,29.08,134.8,29.08,134.8,29.08z M135.07,25.45 c-0.01,0-0.02,0-0.03,0c-0.09-0.02-0.15-0.11-0.14-0.2c0.09-0.46,0.2-0.92,0.32-1.37c0.03-0.09,0.12-0.14,0.21-0.12 c0.09,0.03,0.14,0.12,0.12,0.21c-0.12,0.44-0.23,0.89-0.32,1.34C135.22,25.4,135.15,25.45,135.07,25.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M136.16,21.97c-0.02,0-0.05,0-0.07-0.01c-0.09-0.04-0.13-0.14-0.09-0.22c0.09-0.21,0.19-0.42,0.29-0.63 c0.04-0.08,0.14-0.12,0.23-0.08c0.08,0.04,0.12,0.14,0.08,0.23c-0.1,0.2-0.2,0.41-0.29,0.61 C136.28,21.93,136.22,21.97,136.16,21.97z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M145.45,13.23c-0.07,0-0.13-0.04-0.16-0.11c-0.03-0.09,0.01-0.19,0.1-0.22c0.22-0.08,0.44-0.15,0.65-0.22 c0.09-0.03,0.19,0.02,0.21,0.11c0.03,0.09-0.02,0.19-0.11,0.21c-0.21,0.07-0.43,0.14-0.64,0.22 C145.49,13.23,145.47,13.23,145.45,13.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M166.5,33.68c-0.02,0-0.04,0-0.05-0.01c-0.09-0.03-0.14-0.13-0.11-0.22c0.14-0.43,0.27-0.86,0.38-1.3 c0.02-0.09,0.12-0.15,0.21-0.13c0.09,0.02,0.15,0.11,0.13,0.21c-0.11,0.45-0.24,0.89-0.38,1.33 C166.63,33.64,166.57,33.68,166.5,33.68z M167.25,30.18c-0.01,0-0.01,0-0.02,0c-0.09-0.01-0.16-0.09-0.15-0.19 c0.05-0.45,0.07-0.9,0.08-1.35c0-0.09,0.08-0.17,0.17-0.17c0.09,0,0.17,0.08,0.17,0.17c-0.01,0.46-0.04,0.92-0.08,1.38 C167.41,30.12,167.34,30.18,167.25,30.18z M167.22,26.6c-0.09,0-0.16-0.06-0.17-0.15c-0.05-0.45-0.12-0.9-0.21-1.33 c-0.02-0.09,0.04-0.18,0.13-0.2c0.09-0.02,0.18,0.04,0.2,0.13c0.09,0.45,0.16,0.91,0.22,1.36c0.01,0.09-0.06,0.18-0.15,0.19 C167.23,26.6,167.23,26.6,167.22,26.6z M166.42,23.11c-0.07,0-0.14-0.04-0.16-0.11c-0.15-0.42-0.32-0.85-0.5-1.26 c-0.04-0.09,0-0.19,0.09-0.23c0.09-0.04,0.19,0,0.23,0.09c0.19,0.42,0.36,0.85,0.51,1.28c0.03,0.09-0.02,0.19-0.1,0.22 C166.45,23.11,166.43,23.11,166.42,23.11z M164.87,19.89c-0.06,0-0.11-0.03-0.14-0.08c-0.24-0.38-0.5-0.76-0.76-1.11 c-0.06-0.08-0.04-0.18,0.03-0.24c0.08-0.06,0.18-0.04,0.24,0.03c0.27,0.37,0.54,0.75,0.78,1.14c0.05,0.08,0.03,0.19-0.05,0.24 C164.93,19.88,164.9,19.89,164.87,19.89z M162.65,17.08c-0.04,0-0.09-0.02-0.12-0.05c-0.32-0.32-0.65-0.63-0.99-0.92 c-0.07-0.06-0.08-0.17-0.02-0.24c0.06-0.07,0.17-0.08,0.24-0.02c0.35,0.3,0.69,0.61,1.01,0.94c0.07,0.07,0.07,0.18,0,0.24 C162.73,17.07,162.69,17.08,162.65,17.08z M159.87,14.83c-0.03,0-0.06-0.01-0.09-0.03c-0.38-0.24-0.77-0.47-1.17-0.68 c-0.08-0.04-0.11-0.15-0.07-0.23c0.04-0.08,0.15-0.12,0.23-0.07c0.4,0.21,0.8,0.45,1.19,0.7c0.08,0.05,0.1,0.16,0.05,0.24 C159.98,14.8,159.92,14.83,159.87,14.83z M156.66,13.23c-0.02,0-0.04,0-0.06-0.01c-0.42-0.15-0.85-0.29-1.29-0.41 c-0.09-0.03-0.14-0.12-0.12-0.21c0.02-0.09,0.12-0.14,0.21-0.12c0.44,0.12,0.88,0.26,1.32,0.42c0.09,0.03,0.13,0.13,0.1,0.22 C156.8,13.19,156.73,13.23,156.66,13.23z M148.25,12.48c-0.08,0-0.15-0.06-0.17-0.14c-0.02-0.09,0.05-0.18,0.14-0.2 c0.45-0.08,0.91-0.14,1.37-0.18c0.09-0.01,0.18,0.06,0.19,0.15c0.01,0.09-0.06,0.18-0.15,0.19c-0.45,0.04-0.9,0.1-1.34,0.18 C148.27,12.48,148.26,12.48,148.25,12.48z M153.18,12.38c-0.01,0-0.01,0-0.02,0c-0.45-0.06-0.9-0.1-1.35-0.12 c-0.09,0-0.17-0.08-0.16-0.18c0-0.09,0.09-0.17,0.18-0.16c0.46,0.02,0.92,0.06,1.37,0.12c0.09,0.01,0.16,0.1,0.15,0.19 C153.34,12.31,153.27,12.38,153.18,12.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M165.33,36.35c-0.03,0-0.06-0.01-0.08-0.02c-0.08-0.05-0.11-0.15-0.07-0.23c0.11-0.2,0.21-0.4,0.31-0.6 c0.04-0.08,0.14-0.12,0.23-0.08c0.08,0.04,0.12,0.14,0.08,0.23c-0.1,0.2-0.21,0.41-0.32,0.61 C165.44,36.31,165.39,36.35,165.33,36.35z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.3551,
    y1: 28.3517,
    x2: 163.507,
    y2: 28.3517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#937DB9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DA99C4"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M161.17,35.69c0.06-0.06,0.07-0.15,0.03-0.23l-1.15-2.08c0.54-0.97,0.92-2.04,1.13-3.16l2.2-0.89 c0.08-0.03,0.13-0.11,0.12-0.19l-0.14-2.85c0-0.08-0.06-0.15-0.14-0.18l-2.28-0.66c-0.32-1.1-0.81-2.12-1.44-3.03l0.93-2.19 c0.03-0.08,0.01-0.17-0.05-0.22l-2.11-1.91c-0.06-0.06-0.15-0.07-0.23-0.03l-2.08,1.15c-0.97-0.54-2.04-0.92-3.16-1.13 l-0.89-2.2c-0.03-0.08-0.11-0.13-0.19-0.12l-2.85,0.14c-0.08,0-0.15,0.06-0.18,0.14l-0.66,2.28c-1.1,0.32-2.12,0.81-3.03,1.44 l-2.19-0.93c-0.08-0.03-0.17-0.01-0.22,0.05l-1.91,2.11c-0.06,0.06-0.07,0.15-0.03,0.23l1.15,2.08 c-0.54,0.97-0.92,2.04-1.13,3.16l-2.2,0.89c-0.08,0.03-0.13,0.11-0.12,0.19l0.14,2.85c0,0.08,0.06,0.15,0.14,0.18l2.28,0.66 c0.32,1.1,0.81,2.12,1.44,3.03l-0.93,2.19c-0.03,0.08-0.01,0.17,0.05,0.22l2.11,1.91c0.06,0.06,0.15,0.07,0.23,0.03l2.08-1.15 c0.97,0.54,2.04,0.92,3.16,1.13l0.89,2.2c0.03,0.08,0.11,0.13,0.19,0.12l2.85-0.14c0.08,0,0.15-0.06,0.18-0.14l0.66-2.28 c1.1-0.32,2.12-0.81,3.03-1.44l2.19,0.93c0.08,0.03,0.17,0.01,0.22-0.05L161.17,35.69z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.93,31.14c-1.19,0-2.3-0.77-2.67-1.97c-0.22-0.71-0.15-1.47,0.2-2.12c0.35-0.66,0.93-1.14,1.65-1.36 c0.71-0.22,1.47-0.15,2.12,0.2c0.66,0.35,1.14,0.93,1.36,1.65c0.45,1.47-0.38,3.03-1.85,3.48 C151.48,31.1,151.2,31.14,150.93,31.14z M150.93,26.07c-0.22,0-0.45,0.03-0.67,0.1c-0.58,0.18-1.06,0.57-1.34,1.11 c-0.29,0.54-0.34,1.15-0.17,1.73c0.37,1.2,1.64,1.88,2.84,1.51c1.2-0.37,1.88-1.64,1.51-2.84l0,0 c-0.18-0.58-0.57-1.06-1.11-1.34C151.66,26.16,151.3,26.07,150.93,26.07z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.88,35.45c-3.77,0-6.93-2.97-7.12-6.78c-0.01-0.12-0.01-0.24-0.01-0.36c0-3.77,2.97-6.93,6.78-7.12 c3.93-0.19,7.29,2.84,7.48,6.77c0.01,0.12,0.01,0.24,0.01,0.36c0,0.39-0.03,0.78-0.09,1.16l-0.51-0.08 c0.06-0.35,0.09-0.71,0.09-1.07c0-0.11,0-0.22-0.01-0.34l0,0c-0.18-3.65-3.3-6.47-6.95-6.28c-1.77,0.09-3.39,0.86-4.58,2.17 c-1.11,1.23-1.71,2.79-1.71,4.44c0,0.11,0,0.23,0.01,0.34c0.18,3.65,3.3,6.47,6.95,6.28c1.2-0.06,2.36-0.44,3.35-1.11l0.29,0.43 c-1.07,0.72-2.32,1.13-3.61,1.19C151.12,35.45,151,35.45,150.88,35.45z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.5676,
    y1: -1.432,
    x2: 136.7467,
    y2: 22.1463
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#937DB9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DA99C4"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M141.61,16.89l-0.73-1.11c0.26-0.57,0.43-1.18,0.49-1.81l1.19-0.59c0.04-0.02,0.07-0.07,0.06-0.11 l-0.21-1.58c-0.01-0.05-0.04-0.08-0.09-0.09l-1.3-0.27c-0.23-0.6-0.54-1.15-0.94-1.63l0.42-1.26c0.01-0.04,0-0.09-0.04-0.12 l-1.27-0.97c-0.04-0.03-0.09-0.03-0.13,0l-1.11,0.73c-0.57-0.26-1.18-0.43-1.81-0.49l-0.59-1.19c-0.02-0.04-0.07-0.07-0.11-0.06 l-1.58,0.21c-0.05,0.01-0.08,0.04-0.09,0.09l-0.27,1.3c-0.6,0.23-1.15,0.54-1.63,0.94l-1.26-0.42c-0.04-0.01-0.09,0-0.12,0.04 l-0.97,1.27c-0.03,0.04-0.03,0.09,0,0.13l0.73,1.11c-0.26,0.57-0.43,1.18-0.49,1.81l-1.19,0.59c-0.04,0.02-0.07,0.07-0.06,0.11 l0.21,1.58c0.01,0.05,0.04,0.08,0.09,0.09l1.3,0.27c0.23,0.6,0.54,1.15,0.94,1.63l-0.42,1.26c-0.01,0.04,0,0.09,0.04,0.12 l1.27,0.97c0.04,0.03,0.09,0.03,0.13,0l1.11-0.73c0.57,0.26,1.18,0.43,1.81,0.49l0.59,1.19c0.02,0.04,0.07,0.07,0.11,0.06 l1.58-0.21c0.05-0.01,0.08-0.04,0.09-0.09l0.27-1.3c0.6-0.23,1.15-0.54,1.63-0.94l1.26,0.42c0.04,0.01,0.09,0,0.12-0.04l0.97-1.27 C141.64,16.98,141.64,16.93,141.61,16.89z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M135.56,15.05c-0.23,0-0.45-0.05-0.67-0.14c-0.41-0.18-0.73-0.5-0.89-0.92c-0.16-0.42-0.16-0.87,0.02-1.28 c0.18-0.41,0.5-0.73,0.92-0.89c0.86-0.34,1.83,0.08,2.17,0.94l0,0c0.34,0.86-0.08,1.83-0.94,2.17 C135.98,15.01,135.77,15.05,135.56,15.05z M135.56,12.21c-0.14,0-0.29,0.03-0.43,0.08c-0.29,0.11-0.52,0.33-0.64,0.62 c-0.12,0.29-0.13,0.6-0.01,0.89c0.11,0.29,0.33,0.52,0.62,0.64c0.28,0.12,0.6,0.13,0.89,0.01c0.6-0.24,0.89-0.91,0.65-1.51 C136.46,12.49,136.03,12.21,135.56,12.21z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M140.76,20.35c-0.05,0-0.1-0.02-0.14-0.07c-0.06-0.07-0.04-0.18,0.03-0.24c0.18-0.13,0.35-0.28,0.52-0.43 c0.07-0.06,0.18-0.06,0.24,0.01c0.06,0.07,0.06,0.18-0.01,0.24c-0.17,0.15-0.35,0.3-0.54,0.44 C140.83,20.34,140.79,20.35,140.76,20.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M135.46,22.11C135.46,22.11,135.46,22.11,135.46,22.11c-0.46-0.01-0.91-0.05-1.36-0.12 c-0.09-0.02-0.16-0.1-0.14-0.2c0.02-0.09,0.1-0.16,0.2-0.14c0.43,0.07,0.87,0.11,1.3,0.12c0.09,0,0.17,0.08,0.17,0.17 C135.63,22.03,135.55,22.11,135.46,22.11z M137.61,21.86c-0.08,0-0.15-0.05-0.17-0.13c-0.02-0.09,0.03-0.18,0.12-0.21 c0.37-0.09,0.73-0.21,1.08-0.35c0.05-0.02,0.11-0.04,0.16-0.07c0.09-0.04,0.19,0,0.22,0.09c0.04,0.09,0,0.19-0.09,0.22 c-0.06,0.02-0.11,0.05-0.17,0.07c-0.37,0.14-0.74,0.27-1.12,0.36C137.64,21.86,137.62,21.86,137.61,21.86z M132.05,21.35 c-0.02,0-0.05,0-0.07-0.02c-0.41-0.19-0.82-0.41-1.2-0.65c-0.08-0.05-0.1-0.16-0.05-0.24c0.05-0.08,0.16-0.1,0.24-0.05 c0.36,0.24,0.75,0.45,1.15,0.63c0.09,0.04,0.12,0.14,0.09,0.23C132.18,21.32,132.12,21.35,132.05,21.35z M129.23,19.31 c-0.05,0-0.09-0.02-0.13-0.06c-0.31-0.33-0.59-0.7-0.84-1.08c-0.05-0.08-0.03-0.18,0.05-0.24c0.08-0.05,0.18-0.03,0.24,0.05 c0.24,0.36,0.51,0.71,0.8,1.03c0.06,0.07,0.06,0.18-0.01,0.24C129.31,19.3,129.27,19.31,129.23,19.31z M127.46,16.31 c-0.07,0-0.14-0.04-0.16-0.12c-0.15-0.43-0.26-0.87-0.34-1.32c-0.02-0.09,0.05-0.18,0.14-0.2c0.09-0.02,0.18,0.05,0.2,0.14 c0.08,0.43,0.19,0.85,0.33,1.27c0.03,0.09-0.02,0.19-0.11,0.22C127.49,16.31,127.48,16.31,127.46,16.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M127.02,12.84c0,0-0.01,0-0.01,0c-0.09-0.01-0.16-0.09-0.16-0.18c0.02-0.23,0.05-0.46,0.08-0.69 c0.02-0.09,0.1-0.16,0.2-0.14c0.09,0.02,0.16,0.1,0.14,0.2c-0.04,0.22-0.06,0.44-0.08,0.66 C127.19,12.78,127.11,12.84,127.02,12.84z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M130.4,6.7c-0.05,0-0.1-0.02-0.14-0.07c-0.06-0.08-0.04-0.18,0.03-0.24c0.18-0.14,0.38-0.27,0.57-0.4 c0.08-0.05,0.19-0.03,0.24,0.05c0.05,0.08,0.03,0.19-0.05,0.24c-0.19,0.12-0.37,0.25-0.55,0.38C130.47,6.69,130.44,6.7,130.4,6.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M144.06,12.49c-0.08,0-0.16-0.06-0.17-0.15c-0.05-0.42-0.14-0.85-0.26-1.26c-0.03-0.09,0.03-0.19,0.12-0.21 c0.09-0.03,0.19,0.03,0.21,0.12c0.12,0.43,0.21,0.87,0.27,1.31c0.01,0.09-0.05,0.18-0.15,0.19 C144.08,12.49,144.07,12.49,144.06,12.49z M142.97,9.24c-0.06,0-0.12-0.03-0.15-0.09c-0.21-0.37-0.46-0.73-0.73-1.06 c-0.06-0.07-0.05-0.18,0.03-0.24c0.07-0.06,0.18-0.05,0.24,0.03c0.28,0.35,0.53,0.72,0.76,1.1c0.05,0.08,0.02,0.19-0.06,0.23 C143.03,9.23,143,9.24,142.97,9.24z M140.69,6.68c-0.04,0-0.07-0.01-0.1-0.03c-0.34-0.26-0.71-0.49-1.09-0.69 c-0.08-0.04-0.11-0.15-0.07-0.23c0.04-0.08,0.15-0.12,0.23-0.07c0.39,0.21,0.78,0.45,1.13,0.72c0.08,0.06,0.09,0.16,0.03,0.24 C140.8,6.66,140.74,6.68,140.69,6.68z M132.89,5.4c-0.07,0-0.14-0.05-0.16-0.12c-0.03-0.09,0.02-0.19,0.11-0.22 c0.42-0.14,0.86-0.25,1.3-0.32c0.09-0.02,0.18,0.05,0.2,0.14c0.02,0.09-0.05,0.18-0.14,0.2c-0.42,0.07-0.84,0.17-1.25,0.31 C132.93,5.4,132.91,5.4,132.89,5.4z M137.59,5.22c-0.01,0-0.03,0-0.04,0c-0.42-0.1-0.84-0.17-1.27-0.21 c-0.09-0.01-0.16-0.09-0.16-0.18c0.01-0.09,0.09-0.17,0.18-0.16c0.44,0.04,0.89,0.11,1.32,0.22c0.09,0.02,0.15,0.11,0.13,0.21 C137.74,5.17,137.67,5.22,137.59,5.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M143.94,15.3c-0.01,0-0.02,0-0.04,0c-0.09-0.02-0.15-0.11-0.13-0.2c0.05-0.22,0.08-0.44,0.11-0.66 c0.01-0.09,0.1-0.16,0.19-0.15c0.09,0.01,0.16,0.1,0.15,0.19c-0.03,0.23-0.07,0.46-0.12,0.69 C144.09,15.25,144.02,15.3,143.94,15.3z"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M135.53,17.46c-2.03,0-3.8-1.51-4.07-3.58c-0.02-0.18-0.04-0.36-0.04-0.54c0-0.9,0.3-1.77,0.85-2.5 c0.67-0.87,1.64-1.43,2.73-1.57c1.09-0.14,2.17,0.15,3.04,0.82c0.87,0.67,1.43,1.64,1.57,2.73c0.04,0.28,0.04,0.56,0.02,0.84 c0,0.01,0,0.02,0,0.04l-0.51-0.04c0.01-0.1,0.01-0.2,0.01-0.3c0-0.16-0.01-0.31-0.03-0.47c-0.12-0.95-0.61-1.8-1.37-2.39 c-0.76-0.59-1.71-0.84-2.66-0.72c-0.95,0.12-1.8,0.61-2.39,1.37c-0.49,0.64-0.75,1.4-0.75,2.19c0,0.16,0.01,0.31,0.03,0.47 c0.26,1.97,2.07,3.36,4.03,3.1c0.65-0.08,1.26-0.34,1.77-0.74l0.32,0.4c-0.58,0.46-1.28,0.75-2.02,0.85 C135.89,17.45,135.71,17.46,135.53,17.46z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.9185,
    y1: 26.3964,
    x2: 82.0281,
    y2: 157.5346
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M145.35,30.82l3.22,0.2c1.59,0.1,2.83,1.43,2.8,3.03l-1.12,76.48c-0.03,1.74-1.46,3.13-3.21,3.09 l-22.13-0.47L145.35,30.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.0737,
    y1: 67.9824,
    x2: 94.3529,
    y2: 73.7883
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M106.7,30.89l40.85-1.97c0.85-0.04,1.55,0.65,1.52,1.49l-2.52,78.8c-0.05,1.68-1.47,3-3.15,2.93l-28.71-1.15 L106.7,30.89z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.7388,
    y1: 69.0579,
    x2: 86.9959,
    y2: 72.3024
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M108.88,32.54l35.93-4.58c0.92-0.12,1.74,0.61,1.72,1.54l-1.75,79.48c-0.02,1.12-0.92,2.03-2.04,2.06 l-26.43,0.77L108.88,32.54z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 148.6863,
    y1: 63.1253,
    x2: 65.7003,
    y2: 85.9208
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M99.44,28.59l39.39-2.45c1.96-0.12,3.62,1.44,3.62,3.4v81.16c0,1.65-1.33,2.98-2.98,2.98h-36.32 c-1.71,0-3.13-1.34-3.22-3.05l-4.19-77.89C95.63,30.58,97.28,28.73,99.44,28.59z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.9047,
    y1: 45.5979,
    x2: 59.1173,
    y2: 68.8883
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M144.44,58.11h-3.97c-0.59,0-1.08-0.48-1.08-1.08V34.96c0-0.59,0.48-1.08,1.08-1.08h3.97 c0.59,0,1.08,0.48,1.08,1.08v22.07C145.52,57.62,145.04,58.11,144.44,58.11z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.4209,
    y1: -0.6795,
    x2: 60.7416,
    y2: 38.2542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M60.6,29.43c0,0-13.14,6.76-19.28-0.48c-4.93-5.82,3.59-1.59,11.72-0.41c0.64,0.09,0.81-0.85,0.19-0.99 c-6.18-1.43-15.39-4.15-15.8-7.81c-0.62-5.51,1.1-3.16,8.01,0.2c6.91,3.36,8.96,2.1,4.69-0.75c-4.26-2.86-12.61-3.21-13.5-6.12 c-0.88-2.92-0.14-7.77-0.11-9.96c0.03-2.19,10.73-1.49,12.38,2.02s1.63,9.97,4.32,12.16c2.69,2.19,1.26-4.07,0.18-7.42 c-1.07-3.35-1.16-5.58,2.69-3.43s4.14,7.94,3.18,11.83c-0.96,3.88-0.31,6.5,0.32,4.64c0.63-1.87,2.07-7.76,1.41-9.95 C60.34,10.76,68.89,16.32,60.6,29.43z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st26"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: -296.1678,
    y1: 2521.3015,
    x2: -328.7839,
    y2: 2494.833,
    gradientTransform: "matrix(0.402 -0.9156 0.9156 0.402 -2143.8799 -1252.3306)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M58.14,33.47c0,0-4.44,11.09-12.02,9.92c-6.1-0.94,1.35-2.87,6.94-6.46c0.44-0.28,0.05-0.95-0.41-0.7 c-4.53,2.4-11.6,5.62-13.78,3.6c-3.3-3.04-1-2.51,5-4.12c6-1.61,6.58-3.46,2.47-2.94c-4.11,0.52-9.4,4.72-11.48,3.41 c-2.08-1.31-4.2-4.67-5.34-6.02c-1.14-1.36,5.76-6.6,8.63-5.32c2.87,1.27,6.28,5.22,9.08,5.13c2.81-0.09-1.39-3.15-3.82-4.63 s-3.67-2.79-0.18-3.52c3.49-0.73,6.74,2.65,8.2,5.54c1.47,2.88,3.26,4.13,2.65,2.66c-0.61-1.47-2.85-5.84-4.41-6.82 C48.09,22.21,56.26,21.08,58.14,33.47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.5106,
    y1: 17.8554,
    x2: 33.6452,
    y2: 147.7124
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M61.61,15.95h62.37c3.44,0,6.28,2.7,6.45,6.13l4.6,90.42c0.14,2.69-1.98,4.96-4.67,5.01l-71.48,1.3 c-2.53,0.05-4.61-1.99-4.61-4.52V23.28C54.27,19.23,57.55,15.95,61.61,15.95z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.32,117.27C69.32,117.27,69.32,117.27,69.32,117.27l-8-0.1c-2.67-0.03-4.85-2.24-4.85-4.91v-12.08 c0-0.09,0.08-0.17,0.17-0.17c0.09,0,0.17,0.08,0.17,0.17v12.08c0,2.49,2.02,4.54,4.51,4.57l8,0.1c0.09,0,0.17,0.08,0.17,0.17 C69.49,117.2,69.42,117.27,69.32,117.27z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.64,96.61c-0.09,0-0.17-0.08-0.17-0.17v-1.96c0-0.09,0.08-0.17,0.17-0.17c0.09,0,0.17,0.08,0.17,0.17v1.96 C56.81,96.53,56.74,96.61,56.64,96.61z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.9976,
    y1: 136.5323,
    x2: 118.738,
    y2: 29.2147
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C4997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA4B7B"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M61.8,15.21c8.52,1.16,37.81,4.73,62.02,2.87c1.1-0.08,2.06,0.75,2.12,1.86l4.83,90.83 c0.07,1.25-0.88,2.31-2.13,2.38c-10.18,0.6-52.13,2.93-67.09,1.37c-0.91-0.1-1.6-0.86-1.61-1.78l-0.56-95.4 C59.37,16.04,60.51,15.04,61.8,15.21z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M62.71,17.57c8.2,1.11,36.38,4.55,59.69,2.76c1.06-0.08,1.99,0.72,2.04,1.79l4.65,87.41 c0.06,1.2-0.85,2.22-2.05,2.29c-9.8,0.58-50.16,2.82-64.56,1.31c-0.88-0.09-1.54-0.83-1.55-1.71l-0.54-91.81 C60.38,18.37,61.47,17.4,62.71,17.57z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M67.97,26.35l0.87,18.74c0.03,0.62,0.53,1.12,1.16,1.14c3.47,0.1,14.28,0.36,20.39,0.04 c0.69-0.04,1.24-0.59,1.26-1.29c0.12-3.51,0.37-13.74-0.43-18.02c-0.13-0.69-0.72-1.2-1.43-1.22l-20.51-0.72 C68.54,25,67.94,25.61,67.97,26.35z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.6006,
    y1: 25.8679,
    x2: 54.2052,
    y2: 71.1196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 79.78,
    cy: 33.05,
    r: 4.03
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.7913,
    y1: 29.3546,
    x2: 59.3959,
    y2: 74.6063
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M73.66,44.88h12.83c0.79,0,1.26-0.87,0.83-1.53c-1.09-1.71-3.37-4.21-7.32-4.1c-3.81,0.11-6.06,2.37-7.2,4 C72.32,43.93,72.82,44.88,73.66,44.88z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119.34,27.98c0.38,0,0.67-0.28,0.66-0.63c-0.01-0.35-0.33-0.63-0.7-0.64l-22.59-0.4 c-0.38-0.01-0.58,0.28-0.46,0.63l0.14,0.4c0.12,0.35,0.53,0.64,0.91,0.64H119.34z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.71,29.8c-0.38-0.01-0.58,0.28-0.46,0.63l0.14,0.4c0.12,0.35,0.53,0.64,0.91,0.64h22.03 c0.38,0,0.67-0.28,0.66-0.63c-0.01-0.35-0.33-0.63-0.7-0.64L96.71,29.8z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.71,33.35c-0.38-0.01-0.58,0.28-0.46,0.63l0.14,0.4c0.12,0.35,0.53,0.64,0.91,0.64h22.03 c0.38,0,0.67-0.28,0.66-0.63c-0.01-0.35-0.33-0.63-0.7-0.64L96.71,33.35z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.2818,
    y1: 33.2521,
    x2: 88.4957,
    y2: 76.4547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C4997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA4B7B"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M111.49,36.45c1.73-0.13,4.98-0.19,6.77-0.22c0.76-0.01,1.42,0.5,1.6,1.24c0.35,1.43,0.82,3.92,0.76,6.55 c-0.02,0.79-0.66,1.42-1.45,1.41l-6.6-0.07c-0.81-0.01-1.49-0.63-1.56-1.44l-0.58-6.21C110.37,37.07,110.84,36.5,111.49,36.45z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.4485,
    y1: 37.5908,
    x2: 110.0836,
    y2: 51.1749
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M117.62,44.18l-1.67-0.72c-0.13-0.06-0.28-0.04-0.4,0.03L114,44.46c-0.3,0.19-0.69-0.05-0.66-0.4 l0.17-1.81c0.01-0.14-0.04-0.28-0.15-0.37l-1.4-1.17c-0.27-0.23-0.17-0.67,0.18-0.75l1.78-0.4c0.14-0.03,0.25-0.13,0.3-0.26 l0.68-1.69c0.13-0.33,0.59-0.37,0.77-0.06l0.93,1.57c0.07,0.12,0.2,0.2,0.34,0.21l1.82,0.12c0.36,0.02,0.53,0.45,0.29,0.71 l-1.2,1.37c-0.09,0.11-0.13,0.25-0.09,0.39l0.44,1.77C118.29,44.03,117.94,44.32,117.62,44.18z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.81,41.77c-0.05-0.08-0.11-0.15-0.18-0.22l-0.91-0.76c-0.1-0.08-0.14-0.21-0.11-0.33 c0.03-0.12,0.12-0.21,0.25-0.24l1.16-0.26c0.27-0.06,0.5-0.25,0.6-0.51l0.44-1.1c0.05-0.12,0.15-0.19,0.28-0.2 c0.12-0.01,0.24,0.05,0.31,0.16l0.31,0.52l-0.08,0.05l-0.31-0.52c-0.05-0.08-0.13-0.12-0.22-0.11c-0.09,0.01-0.16,0.06-0.2,0.15 l-0.44,1.1c-0.12,0.29-0.36,0.5-0.67,0.57l-1.16,0.26c-0.09,0.02-0.15,0.08-0.18,0.17c-0.02,0.09,0.01,0.18,0.08,0.23l0.91,0.76 c0.08,0.07,0.15,0.15,0.2,0.24L113.81,41.77z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.14,43.82c-0.06,0-0.12-0.02-0.17-0.05c-0.11-0.07-0.17-0.18-0.15-0.31l0.08-0.91l0.09,0.01l-0.08,0.91 c-0.01,0.09,0.03,0.17,0.11,0.22c0.08,0.05,0.17,0.05,0.25,0l1.01-0.63c0.26-0.16,0.59-0.19,0.87-0.07l1.09,0.47 c0.08,0.04,0.17,0.02,0.24-0.04c0.07-0.06,0.1-0.15,0.08-0.23l-0.29-1.15c-0.08-0.3,0-0.62,0.21-0.85l0.79-0.89 c0.06-0.07,0.08-0.16,0.04-0.24c-0.03-0.08-0.11-0.14-0.2-0.14l-1.19-0.08c-0.12-0.01-0.24-0.04-0.35-0.09l0.04-0.08 c0.1,0.05,0.21,0.08,0.32,0.09l1.19,0.08c0.12,0.01,0.23,0.09,0.28,0.2c0.05,0.12,0.03,0.25-0.06,0.34l-0.79,0.89 c-0.18,0.21-0.25,0.49-0.19,0.77l0.29,1.15c0.03,0.12-0.01,0.25-0.1,0.33c-0.1,0.08-0.23,0.1-0.34,0.05l-1.09-0.47 c-0.25-0.11-0.55-0.09-0.79,0.06l-1.01,0.63C114.26,43.8,114.2,43.82,114.14,43.82z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 115.96,
    y: 38.82,
    transform: "matrix(0.8604 -0.5096 0.5096 0.8604 -3.6846 64.5558)",
    className: "st2",
    width: 0.09,
    height: 0.36
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.2851,
    y1: 27.7649,
    x2: 77.984,
    y2: 68.1104
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C4997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA4B7B"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M107.42,39.61c0.38,0,0.68-0.28,0.67-0.63c-0.01-0.35-0.32-0.64-0.69-0.65l-10.48-0.38 c-0.38-0.01-0.63,0.28-0.57,0.65l0.06,0.34c0.06,0.37,0.42,0.67,0.8,0.67H107.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.1099,
    y1: 29.4729,
    x2: 79.743,
    y2: 69.8982
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C4997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA4B7B"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M96.9,42.06c-0.38,0-0.62,0.3-0.54,0.67l0.07,0.34c0.08,0.37,0.45,0.66,0.82,0.64l10.19-0.37 c0.38-0.01,0.67-0.31,0.65-0.65c-0.02-0.35-0.34-0.63-0.72-0.63L96.9,42.06z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M121.53,52.11c0.38,0,0.66-0.28,0.64-0.63c-0.02-0.35-0.35-0.63-0.72-0.63l-52.79-0.42 c-0.38,0-0.49,0.24-0.26,0.53l0.49,0.62c0.23,0.29,0.73,0.53,1.11,0.53H121.53z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.65,53.93c-0.38,0-0.49,0.24-0.26,0.53l0.49,0.62c0.23,0.29,0.73,0.53,1.11,0.53h51.54 c0.38,0,0.66-0.28,0.64-0.63c-0.02-0.35-0.35-0.63-0.72-0.63L68.65,53.93z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.407,
    y1: 57.3155,
    x2: 50.1343,
    y2: 93.0046
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M68.46,59.76c1.27-0.1,3.64-0.14,4.95-0.16c0.55-0.01,1.04,0.37,1.17,0.91c0.25,1.05,0.6,2.86,0.56,4.78 c-0.01,0.58-0.48,1.04-1.06,1.03l-4.82-0.05c-0.59-0.01-1.08-0.46-1.14-1.05l-0.42-4.53C67.64,60.21,67.99,59.8,68.46,59.76z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.32,61.62c-0.38-0.02-0.64,0.28-0.58,0.65l0.13,0.87c0.06,0.37,0.41,0.68,0.78,0.68h11.8 c0.38,0,0.68-0.31,0.67-0.68l0-0.29c0-0.38-0.32-0.7-0.69-0.71L77.32,61.62z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.2649,
    y1: 57.4796,
    x2: 81.0906,
    y2: 82.7522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M94.72,59.76c1.27-0.1,3.64-0.14,4.95-0.16c0.55-0.01,1.04,0.37,1.17,0.91c0.25,1.05,0.6,2.86,0.56,4.78 c-0.01,0.58-0.48,1.04-1.06,1.03l-4.82-0.05c-0.59-0.01-1.08-0.46-1.14-1.05l-0.42-4.53C93.9,60.21,94.25,59.8,94.72,59.76z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.58,61.62c-0.38-0.02-0.64,0.28-0.58,0.65l0.13,0.87c0.06,0.37,0.41,0.68,0.78,0.68h11.8 c0.38,0,0.68-0.31,0.67-0.68l0-0.29c0-0.38-0.32-0.7-0.69-0.71L103.58,61.62z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.1844,
    y1: 65.0886,
    x2: 64.0592,
    y2: 102.6559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C4997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA4B7B"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M70.83,70.52c3.16-0.13,10.03-0.57,13.29-0.59c1.38-0.01,2.59,0.51,2.92,1.25 c0.63,1.44,0.55,4.31,0.44,6.96c-0.03,0.79-1.21,1.43-2.65,1.42L72.8,79.48c-1.48-0.01-2.71-0.63-2.84-1.45l-1.06-6.25 C68.79,71.14,69.66,70.57,70.83,70.52z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.9,81.5c-0.37-0.02-0.65,0.26-0.61,0.64l0.31,3.05c0.04,0.37,0.38,0.68,0.75,0.68h16.18 c0.38,0,0.68-0.31,0.68-0.68l-0.02-1.93c0-0.38-0.31-0.7-0.69-0.73L70.9,81.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.1209,
    y1: 85.3234,
    x2: 63.6307,
    y2: 109.5715
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M70.56,89.59c1.17-0.08,3.71-0.34,4.92-0.35c0.51-0.01,0.96,0.3,1.08,0.75c0.23,0.86,0.2,2.57,0.16,4.16 c-0.01,0.47-0.45,0.85-0.98,0.85l-4.45-0.04c-0.55-0.01-1-0.38-1.05-0.86l-0.39-3.73C69.81,89.96,70.13,89.62,70.56,89.59z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.02,96.19c-0.37-0.04-0.67,0.24-0.67,0.61l0.14,7.21c0.01,0.38,0.32,0.68,0.7,0.68h5.12 c0.38,0,0.68-0.31,0.68-0.68l-0.01-6.54c0-0.38-0.31-0.71-0.68-0.75L71.02,96.19z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.1616,
    y1: 85.2785,
    x2: 75.7698,
    y2: 105.7699
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M79.26,89.59c1.17-0.08,3.71-0.34,4.92-0.35c0.51-0.01,0.96,0.3,1.08,0.75c0.23,0.86,0.2,2.57,0.16,4.16 c-0.01,0.47-0.45,0.85-0.98,0.85l-4.45-0.04c-0.55-0.01-1-0.38-1.05-0.86l-0.39-3.73C78.51,89.96,78.83,89.62,79.26,89.59z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.72,96.19c-0.37-0.04-0.67,0.24-0.67,0.61l0.14,7.21c0.01,0.38,0.32,0.68,0.7,0.68h5.12 c0.38,0,0.68-0.31,0.68-0.68l-0.01-6.54c0-0.38-0.31-0.71-0.68-0.75L79.72,96.19z"
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.08,75.81c0,0-0.01,0-0.01,0l-4.45-0.04c-0.64-0.01-1.16-0.44-1.22-1.02l-0.39-3.73 c-0.02-0.22,0.05-0.44,0.19-0.61c0.16-0.19,0.41-0.32,0.68-0.34l0,0c0.37-0.03,0.9-0.07,1.46-0.12c1.18-0.1,2.64-0.22,3.46-0.24 c0.6,0,1.1,0.35,1.25,0.87c0.23,0.86,0.21,2.48,0.17,4.21C97.21,75.36,96.7,75.81,96.08,75.81z M90.91,70.42 c-0.18,0.01-0.34,0.09-0.44,0.21c-0.09,0.1-0.13,0.23-0.11,0.35l0.39,3.73c0.04,0.4,0.42,0.71,0.88,0.71l4.45,0.04 c0,0,0.01,0,0.01,0c0.43,0,0.79-0.3,0.8-0.68c0.04-1.7,0.06-3.3-0.16-4.11c-0.1-0.36-0.48-0.62-0.91-0.62 c-0.81,0.01-2.27,0.13-3.44,0.23C91.81,70.35,91.28,70.39,90.91,70.42L90.91,70.42z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M91.38,70.8c0.93-0.06,2.97-0.27,3.93-0.28c0.41-0.01,0.77,0.24,0.86,0.6c0.19,0.69,0.16,2.06,0.13,3.32 c-0.01,0.38-0.36,0.68-0.78,0.68l-3.55-0.03c-0.44,0-0.8-0.3-0.84-0.69l-0.31-2.98C90.78,71.1,91.04,70.83,91.38,70.8z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.3,71.96c-0.38-0.01-0.6,0.28-0.51,0.64l0.24,0.9c0.1,0.36,0.48,0.66,0.86,0.66h21.76 c0.38,0,0.68-0.31,0.67-0.68l-0.01-0.29c-0.01-0.38-0.32-0.69-0.7-0.7L100.3,71.96z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.6337,
    y1: 52.9448,
    x2: 81.9224,
    y2: 91.7076
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C4997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA4B7B"
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M91.57,71.39L91.57,71.39c0.33-0.19,0.76-0.08,0.94,0.26l0.88,1.57c0.09,0.16,0.32,0.15,0.39-0.02 l2.18-4.84c0.11-0.24,0.47-0.16,0.46,0.1c-0.02,1.48-0.42,4.3-2.78,6.66c0,0-1.3-0.51-2.36-2.81 C91.13,71.97,91.26,71.57,91.57,71.39z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.08,85.35c0,0-0.01,0-0.01,0l-4.45-0.04c-0.64-0.01-1.16-0.44-1.22-1.02l-0.39-3.73 c-0.02-0.22,0.05-0.44,0.19-0.61c0.16-0.19,0.41-0.32,0.68-0.34l0,0c0.37-0.03,0.9-0.07,1.46-0.12c1.18-0.1,2.64-0.22,3.46-0.24 c0.01,0,0.01,0,0.02,0c0.58,0,1.09,0.36,1.23,0.87c0.23,0.86,0.21,2.48,0.17,4.21C97.21,84.89,96.7,85.35,96.08,85.35z  M90.91,79.95c-0.18,0.01-0.34,0.09-0.44,0.21c-0.09,0.1-0.13,0.23-0.11,0.35l0.39,3.73c0.04,0.4,0.42,0.71,0.88,0.71L96.07,85 c0,0,0.01,0,0.01,0c0.43,0,0.79-0.3,0.8-0.68c0.04-1.7,0.06-3.3-0.16-4.11c-0.1-0.36-0.48-0.63-0.91-0.62 c-0.81,0.01-2.27,0.13-3.44,0.23C91.81,79.88,91.28,79.92,90.91,79.95L90.91,79.95z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M91.38,80.33c0.93-0.06,2.97-0.27,3.93-0.28c0.41-0.01,0.77,0.24,0.86,0.6c0.19,0.69,0.16,2.06,0.13,3.32 c-0.01,0.38-0.36,0.68-0.78,0.68l-3.55-0.03c-0.44,0-0.8-0.3-0.84-0.69l-0.31-2.98C90.78,80.63,91.04,80.36,91.38,80.33z"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.3,81.49c-0.38-0.01-0.6,0.28-0.51,0.64l0.24,0.9c0.1,0.36,0.48,0.66,0.86,0.66h21.76 c0.38,0,0.68-0.31,0.67-0.68l-0.01-0.29c-0.01-0.38-0.32-0.69-0.7-0.7L100.3,81.49z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.7915,
    y1: 55.3809,
    x2: 86.0803,
    y2: 94.1436
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C4997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA4B7B"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M91.57,80.92L91.57,80.92c0.33-0.19,0.76-0.08,0.94,0.26l0.88,1.57c0.09,0.16,0.32,0.15,0.39-0.02 l2.18-4.84c0.11-0.24,0.47-0.16,0.46,0.1c-0.02,1.48-0.42,4.3-2.78,6.66c0,0-1.3-0.51-2.36-2.81 C91.13,81.5,91.26,81.1,91.57,80.92z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.08,94.88c0,0-0.01,0-0.01,0l-4.45-0.04c-0.64-0.01-1.16-0.44-1.22-1.02l-0.39-3.73 c-0.02-0.22,0.05-0.44,0.19-0.61c0.16-0.19,0.41-0.32,0.68-0.34l0,0c0.37-0.03,0.9-0.07,1.46-0.12c1.18-0.1,2.64-0.22,3.46-0.24 c0.01,0,0.01,0,0.02,0c0.58,0,1.09,0.36,1.23,0.87c0.23,0.86,0.21,2.48,0.17,4.21C97.21,94.43,96.7,94.88,96.08,94.88z  M90.91,89.48c-0.18,0.01-0.34,0.09-0.44,0.21c-0.09,0.1-0.13,0.23-0.11,0.35l0.39,3.73c0.04,0.4,0.42,0.71,0.88,0.71l4.45,0.04 c0,0,0.01,0,0.01,0c0.43,0,0.79-0.3,0.8-0.68c0.04-1.7,0.06-3.3-0.16-4.11c-0.1-0.36-0.48-0.63-0.91-0.62 c-0.81,0.01-2.27,0.13-3.44,0.23C91.81,89.41,91.28,89.46,90.91,89.48L90.91,89.48z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M91.38,89.87c0.93-0.06,2.97-0.27,3.93-0.28c0.41-0.01,0.77,0.24,0.86,0.6c0.19,0.69,0.16,2.06,0.13,3.32 c-0.01,0.38-0.36,0.68-0.78,0.68l-3.55-0.03c-0.44,0-0.8-0.3-0.84-0.69l-0.31-2.98C90.78,90.16,91.04,89.89,91.38,89.87z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.3,91.02c-0.38-0.01-0.6,0.28-0.51,0.64l0.24,0.9c0.1,0.36,0.48,0.66,0.86,0.66h21.76 c0.38,0,0.68-0.31,0.67-0.68l-0.01-0.29c-0.01-0.38-0.32-0.69-0.7-0.7L100.3,91.02z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.2874,
    y1: 64.9364,
    x2: 82.4042,
    y2: 106.6021
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C4997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA4B7B"
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M91.57,90.45L91.57,90.45c0.33-0.19,0.76-0.08,0.94,0.26l0.88,1.57c0.09,0.16,0.32,0.15,0.39-0.02 l2.18-4.84c0.11-0.24,0.47-0.16,0.46,0.1c-0.02,1.48-0.42,4.3-2.78,6.66c0,0-1.3-0.51-2.36-2.81 C91.13,91.03,91.26,90.64,91.57,90.45z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.08,104.41c0,0-0.01,0-0.01,0l-4.45-0.04c-0.64-0.01-1.16-0.44-1.22-1.02l-0.39-3.73 c-0.02-0.22,0.05-0.44,0.19-0.61c0.16-0.19,0.41-0.32,0.68-0.34l0,0c0.37-0.03,0.9-0.07,1.46-0.12c1.18-0.1,2.64-0.22,3.46-0.24 c0.01,0,0.01,0,0.02,0c0.58,0,1.09,0.36,1.23,0.87c0.23,0.86,0.21,2.48,0.17,4.21C97.21,103.96,96.7,104.41,96.08,104.41z  M90.91,99.01c-0.18,0.01-0.34,0.09-0.44,0.21c-0.09,0.1-0.13,0.23-0.11,0.35l0.39,3.73c0.04,0.4,0.42,0.71,0.88,0.71l4.45,0.04 c0,0,0.01,0,0.01,0c0.43,0,0.79-0.3,0.8-0.68c0.04-1.7,0.06-3.3-0.16-4.11c-0.1-0.36-0.48-0.63-0.91-0.62 c-0.81,0.01-2.27,0.13-3.44,0.23C91.81,98.94,91.28,98.99,90.91,99.01L90.91,99.01z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M91.38,99.4c0.93-0.06,2.97-0.27,3.93-0.28c0.41-0.01,0.77,0.24,0.86,0.6c0.19,0.69,0.16,2.06,0.13,3.32 c-0.01,0.38-0.36,0.68-0.78,0.68l-3.55-0.03c-0.44,0-0.8-0.3-0.84-0.69L90.81,100C90.78,99.7,91.04,99.42,91.38,99.4z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.3,100.56c-0.38-0.01-0.6,0.28-0.51,0.64l0.24,0.9c0.1,0.36,0.48,0.66,0.86,0.66h21.76 c0.38,0,0.68-0.31,0.67-0.68l-0.01-0.29c-0.01-0.38-0.32-0.69-0.7-0.7L100.3,100.56z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.1071,
    y1: 60.2529,
    x2: 94.3959,
    y2: 99.0157
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C4997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA4B7B"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M91.57,99.98L91.57,99.98c0.33-0.19,0.76-0.08,0.94,0.26l0.88,1.57c0.09,0.16,0.32,0.15,0.39-0.02 l2.18-4.84c0.11-0.24,0.47-0.16,0.46,0.1c-0.02,1.48-0.42,4.3-2.78,6.66c0,0-1.3-0.51-2.36-2.81 C91.13,100.57,91.26,100.17,91.57,99.98z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.6168,
    y1: -5.6935,
    x2: 74.9289,
    y2: 32.0448
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M96.66,3.62c-2.25-1.57-4.21-1.54-5.59-1.13c-1.26,0.37-2.07,1.59-1.95,2.89l0.59,6.49l7.08,0.63 C96.79,12.5,101.08,6.69,96.66,3.62z M93.55,8.85c-0.97,0-1.76-0.79-1.76-1.76c0-0.97,0.79-1.76,1.76-1.76 c0.97,0,1.76,0.79,1.76,1.76C95.31,8.06,94.52,8.85,93.55,8.85z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M90.42,9.14c-0.09,0-0.16-0.07-0.17-0.16l-0.09-1.03c-0.01-0.09,0.06-0.18,0.15-0.19 c0.1-0.01,0.18,0.06,0.19,0.15l0.09,1.03c0.01,0.09-0.06,0.18-0.15,0.19C90.43,9.14,90.42,9.14,90.42,9.14z M90.23,7.11 c-0.09,0-0.16-0.07-0.17-0.16l-0.07-0.78c-0.11-1.24,0.67-2.4,1.86-2.75c0.84-0.25,1.71-0.28,2.59-0.11 c0.09,0.02,0.15,0.11,0.13,0.2c-0.02,0.09-0.11,0.15-0.2,0.13c-0.82-0.17-1.63-0.13-2.42,0.1c-1.04,0.31-1.72,1.31-1.62,2.4 l0.07,0.78c0.01,0.09-0.06,0.18-0.15,0.19C90.24,7.11,90.24,7.11,90.23,7.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.7636,
    y1: -3.3013,
    x2: 78.0757,
    y2: 34.4368
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M80.05,16.06V12.8c0-1.13,0.93-2.03,2.06-1.99l22.5,0.77c1,0.03,1.81,0.82,1.87,1.82l0.19,3.14L80.05,16.06z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.44,12.04h-0.97c-0.09,0-0.17-0.08-0.17-0.17c0-0.09,0.08-0.17,0.17-0.17h0.97c0.09,0,0.17,0.08,0.17,0.17 C88.61,11.96,88.53,12.04,88.44,12.04z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.27,15.04c-0.09,0-0.17-0.08-0.17-0.17v-1.32c0-1.02,0.83-1.85,1.85-1.85h3.56c0.09,0,0.17,0.08,0.17,0.17 c0,0.09-0.08,0.17-0.17,0.17h-3.56c-0.83,0-1.51,0.68-1.51,1.51v1.32C81.44,14.96,81.36,15.04,81.27,15.04z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.1484,
    y1: -0.993,
    x2: 83.3401,
    y2: 35.3792
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M73,14.87l39.35,0c1.41,0,2.62,1.02,2.87,2.41l0.03,0.19c0.26,1.53-0.91,2.92-2.46,2.92H72.42 c-0.93,0-1.67-0.78-1.62-1.7l0.09-1.81C70.94,15.76,71.87,14.87,73,14.87z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.5716,
    y1: 68.8646,
    x2: 42.5117,
    y2: 68.8646
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M42.37,68.63c-0.85,0.07-2.32,0.19-3.47,0.24c-0.7,0.03-1.1-0.04-1.33-0.13c0,0.03,0,0.05,0,0.07 c0.01,0.12,0.1,0.22,0.23,0.23c2.19,0.12,3.93,0.04,4.55,0c0.13-0.01,0.2-0.15,0.14-0.26C42.46,68.73,42.42,68.68,42.37,68.63z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.5713,
    y1: 67.8964,
    x2: 42.3722,
    y2: 67.8964
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M38.9,68.87c1.16-0.05,2.63-0.17,3.47-0.24c-0.83-1.02-3.47-1.71-3.47-1.71h-0.75 c-0.51,0.74-0.59,1.44-0.58,1.82C37.8,68.83,38.2,68.9,38.9,68.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.0277,
    y1: 66.5447,
    x2: 39.4192,
    y2: 66.5447
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M38.03,65.7l0.07,1.38c0.01,0.15,0.12,0.28,0.27,0.3c0.15,0.02,0.35,0.02,0.56-0.05 c0.13-0.04,0.23-0.15,0.25-0.29l0.24-1.34H38.03z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.7229,
    y1: 68.7581,
    x2: 29.616,
    y2: 68.7581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M28.34,68.86c-0.37-0.05-0.53-0.24-0.6-0.45c0,0,0,0,0,0.01c-0.05,0.22,0.07,0.44,0.32,0.54 c0.3,0.13,0.63,0.15,0.89,0.14c0.28-0.01,0.53-0.13,0.67-0.31l0,0C29.34,68.93,28.95,68.94,28.34,68.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.7367,
    y1: 67.3004,
    x2: 30.5154,
    y2: 67.3004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M30.07,65.69h-0.62c-0.94-0.02-1.53,1.96-1.72,2.72c0.07,0.2,0.24,0.39,0.6,0.45 c0.61,0.09,1,0.07,1.28-0.07c0.51-0.67,0.76-1.64,0.88-2.21C30.63,65.93,30.07,65.69,30.07,65.69z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.181,
    y1: 65.3846,
    x2: 30.8441,
    y2: 65.3846
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M29.53,64.41l-0.34,1.36c-0.04,0.17,0.04,0.34,0.19,0.42c0.19,0.1,0.46,0.2,0.71,0.17 c0.12-0.01,0.21-0.1,0.25-0.21l0.5-1.43L29.53,64.41z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.3288,
    y1: 70.2479,
    x2: 47.1755,
    y2: 45.5308
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M29.13,64.8c0.42,0.38,1.81,0.43,1.81,0.43c4.98-11.95,7.02-13.65,7.02-13.65 c-0.72,4.51-0.12,14.5-0.12,14.5c0.82,0.36,1.88,0,1.88,0c0.07-7.38,1.2-13.82,2.54-18.9c-3.37-0.08-5.16-1.23-5.74-1.69 C33.71,50.01,29.13,64.8,29.13,64.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.0951,
    y1: 30.6685,
    x2: 11.9704,
    y2: 63.8273
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M37.37,31.74c-0.64,3.18-0.41,8.86-0.26,11.46c0.04,0.73-0.47,1.74-0.88,2.43 c-0.06,0.11-0.02,0.25,0.09,0.3c0.69,0.35,3.02,1.45,5.73,1.59c0.18,0.01,0.34-0.11,0.39-0.29c2.01-7.49,4.34-12.28,4.34-12.28 C44.2,30.85,37.37,31.74,37.37,31.74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.7853,
    y1: 59.2258,
    x2: 35.5822,
    y2: 57.6321
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M38.29,51.3c-0.03,0-0.06-0.01-0.08-0.02c-0.08-0.05-0.1-0.14-0.05-0.22c0.03-0.04,0.67-1.09,1.97-1.71 c0.08-0.04,0.17-0.01,0.21,0.07c0.04,0.08,0,0.17-0.07,0.21c-1.22,0.59-1.83,1.58-1.84,1.59C38.4,51.27,38.34,51.3,38.29,51.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.8002,
    y1: 41.1436,
    x2: 30.88,
    y2: 46.3861
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M33.38,40.86c0.2,1.48,0.81,3.09,2.02,4.81l0.46-0.37c0,0-0.53-2.15-0.23-4.6 C34.88,40.55,34,40.7,33.38,40.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.9167,
    y1: 27.1546,
    x2: 8.964,
    y2: 60.1638
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M38.08,35.66l-0.71-3.92c0,0-4.75,3.63-4,9.12c0.62-0.16,1.5-0.31,2.25-0.16 C35.84,38.94,36.49,37.03,38.08,35.66z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.8829,
    y1: 34.0141,
    x2: 14.9301,
    y2: 67.0235
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M46.77,34.96l-1.83,3.95c0.3,2.39,1.58,3.42,2.96,3.81c0.09-1.09,0.36-1.97,0.62-2.57 C46.75,38.32,46.77,34.96,46.77,34.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.8982,
    y1: 41.6395,
    x2: 52.5605,
    y2: 41.6395
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M48.51,40.15c-0.26,0.61-0.53,1.49-0.62,2.57c3.69,1.43,4.66-1.34,4.66-1.34l-0.68-0.12 C50.34,41.42,49.27,40.92,48.51,40.15z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.3662,
    y1: 29.18,
    x2: 43.3153,
    y2: 37.8866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M45.08,30.08l-0.89,3.26c-0.1,0.37-0.5,0.56-0.85,0.42c-0.38-0.15-0.86-0.36-1.28-0.58 c-0.44-0.24-0.58-0.81-0.3-1.23l1.84-2.75L45.08,30.08z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.4073,
    y1: 45.0549,
    x2: 54.822,
    y2: 45.0549
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M54.25,39.2l-22.7,8.26c-0.95,0.35-1.41,1.43-0.99,2.35l0.07,0.15c0.37,0.82,1.34,1.17,2.15,0.8l22.04-10.2 L54.25,39.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.4784,
    y1: 34.2289,
    x2: 75.8889,
    y2: 34.2289
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#937DB9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DA99C4"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st64",
    cx: 64.68,
    cy: 34.23,
    rx: 11.21,
    ry: 11
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.2153,
    y1: 34.2289,
    x2: 77.1521,
    y2: 34.2289
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M64.68,21.99c-6.89,0-12.47,5.48-12.47,12.24c0,6.76,5.58,12.24,12.47,12.24c6.89,0,12.47-5.48,12.47-12.24 C77.15,27.47,71.57,21.99,64.68,21.99z M64.68,44.67c-5.87,0-10.64-4.68-10.64-10.44c0-5.77,4.76-10.44,10.64-10.44 c5.87,0,10.64,4.68,10.64,10.44C75.32,40,70.56,44.67,64.68,44.67z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.16,35.75c-0.04,0-0.08-0.03-0.08-0.07c-0.04-0.29-0.06-0.58-0.08-0.88c0-0.05,0.03-0.09,0.08-0.09 c0.05-0.01,0.09,0.03,0.09,0.08c0.01,0.29,0.04,0.58,0.08,0.86c0.01,0.05-0.03,0.09-0.07,0.1 C53.17,35.75,53.17,35.75,53.16,35.75z M53.25,32.32c-0.01,0-0.01,0-0.02,0c-0.05-0.01-0.08-0.05-0.07-0.1 c0.14-0.79,0.37-1.56,0.67-2.3c1.8-4.36,6.06-7.18,10.85-7.18c2.23,0,4.41,0.62,6.28,1.79c0.04,0.03,0.05,0.08,0.03,0.12 c-0.03,0.04-0.08,0.05-0.12,0.03c-1.85-1.16-3.99-1.77-6.19-1.77c-4.72,0-8.92,2.78-10.69,7.07c0,0,0,0,0,0 c-0.3,0.73-0.52,1.49-0.66,2.27C53.33,32.29,53.29,32.32,53.25,32.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: -275.4569,
    y1: 1689.2386,
    x2: -279.7427,
    y2: 1694.9083,
    gradientTransform: "matrix(0.9897 -0.1428 0.1428 0.9897 77.5879 -1683.4264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M47.02,27.6c0.01,0.06-0.74,3.72-0.74,3.72l-2.08-0.47l0.19-3.57C44.39,27.27,46.89,26.67,47.02,27.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: -278.73,
    y1: 1690.6063,
    x2: -273.6106,
    y2: 1690.6063,
    gradientTransform: "matrix(0.9897 -0.1428 0.1428 0.9897 77.5879 -1683.4264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M44.86,28.07l-0.25,1.87c0,0.02,0,0.05,0,0.07c0.02,0.15,0.13,0.65,0.63,0.5 c0.46-0.13,0.88-0.24,1.17-0.15c0.13,0.04,0.21,0.17,0.18,0.31c-0.07,0.33-0.23,1.08-0.48,1.71c-0.05,0.13-0.19,0.19-0.32,0.16 c-0.39-0.12-1.22-0.38-1.83-0.75c-0.08-0.05-0.13-0.14-0.13-0.24c0.02-0.47,0.08-1.91,0.03-2.31c-0.04-0.38-0.51-0.6-0.71-0.69 c-0.07-0.03-0.12-0.08-0.14-0.14c-0.09-0.23-0.22-0.78,0.46-1c0.14-0.05,0.22-0.2,0.17-0.34c-0.1-0.28-0.14-0.71,0.38-0.95 c0.54-0.24,0.94,0.05,1.15,0.28c0.09,0.09,0.23,0.11,0.34,0.04c0.06-0.04,0.14-0.05,0.24,0.01c0.13,0.08,0.3,0.03,0.37-0.11 c0.13-0.26,0.39-0.55,0.92-0.46c0.93,0.16,1.04,1.19,0.79,1.8c-0.25,0.61-1.25,0.37-1.75,0.07c-0.38-0.23-0.88,0.01-1.09,0.14 C44.92,27.92,44.87,27.99,44.86,28.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: -281.7339,
    y1: 1693.7286,
    x2: -278.2963,
    y2: 1690.2018,
    gradientTransform: "matrix(0.9897 -0.1428 0.1428 0.9897 77.5879 -1683.4264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M43.78,29.92c0,0,0.38-1.07-0.01-1.34c-0.39-0.26-0.98-0.13-0.85,0.65C43.08,30.2,43.78,29.92,43.78,29.92 z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.1381,
    y1: 43.7837,
    x2: 33.2179,
    y2: 49.0262
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M35.67,45.23l2.15-0.17l0.93,0.86c0,0-0.22,0.3-0.91,0.13c-0.69-0.17-1.63-0.22-1.63-0.22 s-0.95,0.43-0.96-0.37L35.67,45.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.0652,
    y1: 41.0919,
    x2: 53.7348,
    y2: 41.0919
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M52.29,41.89c0.19,0.14,0.82-0.16,1.21-0.37c0.19-0.1,0.28-0.32,0.22-0.53c-0.09-0.3-0.25-0.68-0.44-0.72 C52.95,40.19,51.52,41.29,52.29,41.89z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32,50.45c-0.01,0-0.02,0-0.03,0c-0.89-0.31-1.09-0.83-1.11-1.22c-0.02-0.56,0.33-1.09,0.88-1.3l2.73-1.06 c0.04-0.02,0.09,0,0.11,0.05c0.02,0.04,0,0.09-0.05,0.11l-2.73,1.06c-0.48,0.19-0.79,0.65-0.77,1.14c0.02,0.48,0.36,0.84,1,1.06 c0.04,0.02,0.07,0.06,0.05,0.11C32.07,50.42,32.03,50.45,32,50.45z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.34,46.7c-0.03,0-0.07-0.02-0.08-0.05c-0.02-0.04,0-0.09,0.05-0.11l0.35-0.14c0.04-0.02,0.09,0,0.11,0.05 c0.02,0.04,0,0.09-0.05,0.11l-0.35,0.14C35.36,46.69,35.35,46.7,35.34,46.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.082,
    y1: 80.5109,
    x2: -8.3421,
    y2: 153.865
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M44.57,117.84c-0.22,0-0.4-0.18-0.4-0.4V69.79c0-0.22,0.18-0.4,0.4-0.4c0.22,0,0.4,0.18,0.4,0.4v47.65 C44.97,117.66,44.79,117.84,44.57,117.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.9828,
    y1: 75.1543,
    x2: -14.4412,
    y2: 148.5084
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M33.77,117.84c-0.22,0-0.4-0.18-0.4-0.4V69.79c0-0.22,0.18-0.4,0.4-0.4s0.4,0.18,0.4,0.4v47.65 C34.17,117.66,33.99,117.84,33.77,117.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.8278,
    y1: 93.7661,
    x2: 28.012,
    y2: 93.7661
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ABDBE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AADAE2"
    }
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M7.23,118.14c-0.05,0-0.1-0.01-0.16-0.03c-0.2-0.09-0.3-0.32-0.21-0.52l20.39-47.95 c0.09-0.2,0.32-0.3,0.52-0.21c0.2,0.09,0.3,0.32,0.21,0.52L7.59,117.9C7.53,118.05,7.38,118.14,7.23,118.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.4204,
    y1: 93.7661,
    x2: 40.6046,
    y2: 93.7661
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ABDBE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AADAE2"
    }
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M19.82,118.14c-0.05,0-0.1-0.01-0.16-0.03c-0.2-0.09-0.3-0.32-0.21-0.52l20.39-47.95 c0.09-0.2,0.32-0.3,0.52-0.21c0.2,0.09,0.3,0.32,0.21,0.52L20.19,117.9C20.12,118.05,19.97,118.14,19.82,118.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.9555,
    y1: 69.6655,
    x2: 45.754,
    y2: 69.6655
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ABDBE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AADAE2"
    }
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M45.19,70.23H26.52c-0.31,0-0.56-0.25-0.56-0.56l0,0c0-0.31,0.25-0.56,0.56-0.56h18.67 c0.31,0,0.56,0.25,0.56,0.56l0,0C45.75,69.98,45.5,70.23,45.19,70.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.0973,
    y1: 77.1214,
    x2: 37.5246,
    y2: 77.1214
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ABDBE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AADAE2"
    }
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M37.13,77.52H24.5c-0.22,0-0.4-0.18-0.4-0.4c0-0.22,0.18-0.4,0.4-0.4h12.63c0.22,0,0.4,0.18,0.4,0.4 C37.52,77.34,37.35,77.52,37.13,77.52z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.6207,
    y1: 86.1908,
    x2: 33.2506,
    y2: 86.1908
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ABDBE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AADAE2"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.62,
    y: 85.79,
    className: "st77",
    width: 12.63,
    height: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.8691,
    y1: 95.2603,
    x2: 29.499,
    y2: 95.2603
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ABDBE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AADAE2"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.87,
    y: 94.86,
    className: "st78",
    width: 12.63,
    height: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.5361,
    y1: 104.3297,
    x2: 25.9634,
    y2: 104.3297
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ABDBE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AADAE2"
    }
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M25.56,104.73H12.93c-0.22,0-0.4-0.18-0.4-0.4c0-0.22,0.18-0.4,0.4-0.4h12.63c0.22,0,0.4,0.18,0.4,0.4 C25.96,104.55,25.78,104.73,25.56,104.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.7324,
    y1: 113.3993,
    x2: 22.1596,
    y2: 113.3993
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ABDBE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AADAE2"
    }
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M21.76,113.8H9.13c-0.22,0-0.4-0.18-0.4-0.4c0-0.22,0.18-0.4,0.4-0.4h12.63c0.22,0,0.4,0.18,0.4,0.4 C22.16,113.62,21.98,113.8,21.76,113.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.1681,
    y1: -488.5096,
    x2: 141.9184,
    y2: -479.7502,
    gradientTransform: "matrix(0.987 0.1608 -0.1608 0.987 -148.9881 545.6265)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M65.67,94.34c-0.02,0.04-1.39,1.05-1.39,1.05s0.3,2.16,1.53,3.01c1.35,0.94,3.25-0.77,3.25-0.77 s1.51,0.36,2.32-2.79c0.18-0.72-0.88-0.78-2.17-0.65C67.55,94.36,65.67,94.34,65.67,94.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.5646,
    y1: 100.3812,
    x2: 68.9173,
    y2: 141.2992
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M63.11,101.71c0.53-0.37,1.13-0.64,1.75-0.82c0.24-0.06,1.51,0.31,2.29,0.29c1.08-0.02,2.18-0.52,3.07-0.29 c0.88,0.22,1.61,0.51,2.02,0.8c1.25,0.89,1.98,2.54,2.43,4.19c-0.85,0.87-1.91,1.25-1.91,1.25l-0.2,7.98l-4.72,2.41l-5.38-2.7 l0.19-7.79c0,0-1.71-0.8-1.83-1.09C60.7,105.65,61.61,102.75,63.11,101.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.7365,
    y1: 104.1955,
    x2: 68.6987,
    y2: 125.8444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5431C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C1119"
    }
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M60.91,105.9c0,0-2.29,6.35,2.93,8.96c1.08-0.14,0.67-1.95,0.67-1.95s-2.27-0.5-1.59-5.8 C62.29,106.6,60.91,105.9,60.91,105.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: -2846.2405,
    y1: 104.149,
    x2: -2837.2783,
    y2: 125.7979,
    gradientTransform: "matrix(-1 0 0 1 -2770.6162 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5431C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C1119"
    }
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M74.57,105.9c0,0,1.58,6.63-2.93,8.96c-1.08-0.14-0.67-1.95-0.67-1.95s1.83-0.9,1.59-5.8 C73.18,106.6,74.57,105.9,74.57,105.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.6966,
    y1: 107.0237,
    x2: 67.2336,
    y2: 125.7731
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M71.52,115.31h-7.89c-0.68,0-1.23-0.55-1.23-1.23v-4.53c0-0.68,0.55-1.23,1.23-1.23h7.89 c0.68,0,1.23,0.55,1.23,1.23v4.53C72.75,114.76,72.2,115.31,71.52,115.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.8635,
    y1: 106.2645,
    x2: 87.7611,
    y2: 106.2645,
    gradientTransform: "matrix(1 7.700000e-03 -7.700000e-03 1 -8.969 11.4437)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E769F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B1F3D"
    }
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M77.29,117.38c-1.18-0.27-3.92-0.13-3.92-0.13l-0.11,0.3l-0.18,1.5c0,0,2.61,0.47,3.89,0.47 c0.13,0,0.25-0.02,0.36-0.05c0.04-0.04,0.08-0.07,0.11-0.11C77.98,118.76,77.82,117.89,77.29,117.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.1553,
    y1: 90.9794,
    x2: 77.8551,
    y2: 90.9278,
    gradientTransform: "matrix(1 7.700000e-03 -7.700000e-03 1 -2.88 26.8373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74C4B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#45AED9"
    }
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M77.4,117.41c-0.04-0.01-0.08-0.02-0.12-0.03c0.54,0.51,0.69,1.38,0.15,1.98 c-0.04,0.04-0.07,0.08-0.11,0.11C78.28,119.17,78.4,117.69,77.4,117.41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 76.3088,
    y1: 109.5159,
    x2: 71.1392,
    y2: 123.5184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5431C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C1119"
    }
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M72.58,117.17l0.46,0.02c0.25,0.01,0.48,0.13,0.65,0.34c0.17,0.2,0.25,0.48,0.24,0.75 c-0.01,0.22-0.1,0.43-0.25,0.57c-0.15,0.15-0.34,0.22-0.54,0.21L72.43,119L72.58,117.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.1658,
    y1: 90.7955,
    x2: 77.8648,
    y2: 90.7439,
    gradientTransform: "matrix(1 7.700000e-03 -7.700000e-03 1 -2.88 26.8373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74C4B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#45AED9"
    }
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M75.06,118.76c-0.03,0-0.06-0.02-0.07-0.06c-0.12-0.47-0.58-0.95-0.58-0.95c-0.03-0.03-0.03-0.08,0-0.11 c0.03-0.03,0.07-0.03,0.1,0c0.02,0.02,0.49,0.51,0.62,1.03c0.01,0.04-0.01,0.08-0.05,0.09 C75.07,118.76,75.07,118.76,75.06,118.76z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.148,
    y1: 90.7662,
    x2: 77.8674,
    y2: 90.7149,
    gradientTransform: "matrix(1 7.700000e-03 -7.700000e-03 1 -2.88 26.8373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74C4B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#45AED9"
    }
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M74.44,118.72c-0.01,0-0.01,0-0.02,0c-0.04-0.01-0.06-0.06-0.05-0.1c0.15-0.55,0.74-0.99,0.76-1.01 c0.03-0.02,0.07-0.01,0.1,0.02c0.02,0.03,0.01,0.08-0.02,0.11c-0.01,0-0.57,0.43-0.71,0.93 C74.49,118.7,74.46,118.72,74.44,118.72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.7243,
    y1: -73.6083,
    x2: 94.3949,
    y2: -73.6602,
    gradientTransform: "matrix(0.9984 0.0564 -0.0564 0.9984 -24.1247 186.3458)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74C4B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#45AED9"
    }
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M76.32,118.84c-0.03,0-0.06-0.02-0.07-0.06c-0.1-0.48-0.54-0.98-0.54-0.98c-0.03-0.03-0.03-0.08,0-0.11 c0.03-0.03,0.07-0.03,0.1,0c0.02,0.02,0.47,0.54,0.58,1.06c0.01,0.04-0.01,0.08-0.05,0.09 C76.33,118.83,76.32,118.84,76.32,118.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.6834,
    y1: -73.6375,
    x2: 94.424,
    y2: -73.6887,
    gradientTransform: "matrix(0.9984 0.0564 -0.0564 0.9984 -24.1247 186.3458)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74C4B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#45AED9"
    }
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M75.69,118.76c-0.01,0-0.02,0-0.02,0c-0.04-0.01-0.05-0.06-0.04-0.1c0.18-0.54,0.78-0.95,0.81-0.97 c0.03-0.02,0.07-0.01,0.09,0.03c0.02,0.04,0.01,0.08-0.02,0.1c-0.01,0-0.59,0.4-0.75,0.89 C75.75,118.74,75.72,118.76,75.69,118.76z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: -3529.4846,
    y1: 85.1349,
    x2: -3524.585,
    y2: 85.1349,
    gradientTransform: "matrix(-0.9998 -0.02 -0.02 0.9998 -3465.8855 -37.3855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E769F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B1F3D"
    }
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M57,117.24c1.19-0.24,3.92-0.01,3.92-0.01l0.1,0.3l0.15,1.5c0,0-2.62,0.39-3.9,0.35 c-0.13,0-0.25-0.03-0.36-0.06c-0.04-0.04-0.08-0.07-0.11-0.11C56.28,118.6,56.46,117.73,57,117.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: -7507.5962,
    y1: 45.3235,
    x2: -7511.8823,
    y2: 45.2721,
    gradientTransform: "matrix(-0.9998 -0.02 -0.02 0.9998 -7449.4976 -77.1972)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74C4B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#45AED9"
    }
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M56.89,117.26c0.04-0.01,0.08-0.02,0.12-0.03c-0.55,0.49-0.73,1.36-0.2,1.97 c0.04,0.04,0.07,0.08,0.11,0.11C55.96,118.99,55.89,117.51,56.89,117.26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.9513,
    y1: 105.2962,
    x2: 60.779,
    y2: 119.3061
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5431C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C1119"
    }
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M61.71,117.17l-0.46,0.01c-0.25,0-0.49,0.12-0.66,0.32c-0.17,0.2-0.27,0.47-0.26,0.74 c0.01,0.22,0.09,0.43,0.24,0.58c0.15,0.15,0.34,0.23,0.54,0.22l0.71-0.03L61.71,117.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: -7507.5977,
    y1: 45.147,
    x2: -7511.8833,
    y2: 45.0956,
    gradientTransform: "matrix(-0.9998 -0.02 -0.02 0.9998 -7449.4976 -77.1972)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74C4B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#45AED9"
    }
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M59.19,118.68c0.03,0,0.06-0.02,0.07-0.05c0.13-0.47,0.6-0.93,0.61-0.94c0.03-0.03,0.03-0.08,0.01-0.11 c-0.02-0.03-0.07-0.03-0.1-0.01c-0.02,0.02-0.51,0.49-0.65,1.01c-0.01,0.04,0.01,0.08,0.05,0.1 C59.18,118.68,59.19,118.68,59.19,118.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: -7507.5898,
    y1: 45.1179,
    x2: -7511.8838,
    y2: 45.0664,
    gradientTransform: "matrix(-0.9998 -0.02 -0.02 0.9998 -7449.4976 -77.1972)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74C4B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#45AED9"
    }
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M59.82,118.67c0.01,0,0.01,0,0.02,0c0.04-0.01,0.06-0.05,0.05-0.09c-0.14-0.56-0.71-1.01-0.74-1.03 c-0.03-0.02-0.07-0.02-0.1,0.02c-0.02,0.03-0.01,0.08,0.02,0.11c0.01,0,0.56,0.45,0.69,0.95 C59.76,118.64,59.79,118.66,59.82,118.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: -7483.9521,
    y1: 250.0654,
    x2: -7488.2651,
    y2: 250.0136,
    gradientTransform: "matrix(-0.9996 0.0288 0.0288 0.9996 -7432.48 83.8186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74C4B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#45AED9"
    }
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M57.94,118.72c0.03,0,0.06-0.02,0.07-0.06c0.11-0.48,0.56-0.96,0.56-0.97c0.03-0.03,0.03-0.08,0-0.11 c-0.03-0.03-0.07-0.03-0.1,0c-0.02,0.02-0.48,0.52-0.6,1.04c-0.01,0.04,0.01,0.08,0.05,0.09 C57.93,118.72,57.93,118.72,57.94,118.72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: -7483.9766,
    y1: 250.0362,
    x2: -7488.2476,
    y2: 249.985,
    gradientTransform: "matrix(-0.9996 0.0288 0.0288 0.9996 -7432.48 83.8186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74C4B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#45AED9"
    }
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M58.56,118.67c0.01,0,0.02,0,0.02,0c0.04-0.01,0.06-0.06,0.04-0.1c-0.17-0.55-0.76-0.97-0.78-0.99 c-0.03-0.02-0.07-0.01-0.09,0.02c-0.02,0.04-0.01,0.08,0.02,0.11c0.01,0,0.58,0.42,0.73,0.91 C58.51,118.65,58.53,118.67,58.56,118.67z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.5,
    y1: 109.2456,
    x2: 65.0608,
    y2: 119.341
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D4495"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#374F9E"
    }
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M77.62,112.69c-0.54-1.24-1.85-1.44-2.97-0.86c-0.02,0.03-7.1,3.65-13.34,5.24 c0.18,0.57,0.27,1.18,0.29,1.78c0,0.13,0,0.27-0.01,0.39c4.79-0.25,9.98-1.84,14.44-3.24C77.42,115.55,78.21,114.05,77.62,112.69 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.3469,
    y1: 118.3002,
    x2: 62.8246,
    y2: 109.3185
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D4495"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#374F9E"
    }
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M72.61,118.94c-0.02-0.69,0.12-1.33,0.4-1.93c0.01-0.03,0.02-0.05,0.03-0.08 c-0.36-0.11-0.82-0.26-1.42-0.47c-4.43-1.52-7.81-3.05-11.04-4.81c-1.25-0.68-2.68-0.23-3.08,1.26 c-0.36,1.32,0.43,2.45,1.62,2.85c3.57,1.19,1.71,0.86,2.88,1.23c3.13,0.97,7.03,1.85,10.62,2.09 C72.62,119.04,72.62,118.99,72.61,118.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.604,
    y1: 105.983,
    x2: 67.4847,
    y2: 95.6078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5431C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C1119"
    }
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M64.87,100.89c0,0,0.48,2.07,2.79,2.02c2.36-0.04,2.57-2.03,2.57-2.03l-1.54-0.33l-0.13-1.72l-2.32,0.17 l-0.04,1.63L64.87,100.89z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.4467,
    y1: -163.2552,
    x2: 296.8182,
    y2: -172.2834,
    gradientTransform: "matrix(0.987 0.1608 -0.1608 0.987 -251.5861 213.688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5431C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C1119"
    }
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M66.57,93.98c0,0-2.65,5.14,0.49,6.39c2.22,0.88,3.61-3.41,3.2-4.58c-0.64-1.8-1.06-1.58-1.06-1.58 L66.57,93.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.1992,
    y1: -489.7425,
    x2: 141.4174,
    y2: -479.8862,
    gradientTransform: "matrix(0.987 0.1608 -0.1608 0.987 -148.9881 545.6265)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M70.9,93.51c1.31,0.36,0.19,3.2-1.78,2.53c-1.97-0.67-2.75-0.66-3.06-0.12c-0.31,0.54-0.37,2.47-1.04,1.52 c-0.73-1.04-1.14-3.14-0.24-3.81c0.8-0.6,0.99-1.54,1.95-1.51c1.28,0.04,2.26-0.52,2.84-0.11C70.22,92.48,69.93,93.25,70.9,93.51 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: -265.1626,
    y1: 212.9515,
    x2: -264.5805,
    y2: 198.8034,
    gradientTransform: "matrix(0.9911 -0.1329 0.1329 0.9911 300.5545 -144.897)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5431C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C1119"
    }
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M65.93,96.37c0,0-0.57-0.61-0.66,0.13c-0.09,0.73,0.2,1.68,0.54,1.16C66.16,97.13,65.93,96.37,65.93,96.37 z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.6448,
    y1: 105.5497,
    x2: 67.3436,
    y2: 119.9627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M68.19,110.22c0.05,0.37-0.14,0.71-0.51,0.76c-0.37,0.05-0.72-0.2-0.77-0.57 c-0.05-0.37,0.11-0.74,0.49-0.79C67.76,109.56,68.13,109.85,68.19,110.22z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M152.01,60.88l0.47-0.2l0,0c0.07-0.03,0.15,0,0.18,0.07c0.03,0.07,0,0.15-0.07,0.18c0,0,0,0,0,0l-0.48,0.19 c-0.07,0.03-0.14-0.01-0.17-0.07C151.91,60.99,151.94,60.91,152.01,60.88L152.01,60.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M153.56,60.19l0.46-0.22l0,0c0.07-0.04,0.16,0,0.2,0.07c0.04,0.07,0,0.16-0.07,0.2c0,0,0,0,0,0l-0.47,0.22 c-0.07,0.03-0.16,0-0.19-0.07C153.46,60.31,153.49,60.23,153.56,60.19L153.56,60.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M155.08,59.42l0.45-0.25l0,0c0.08-0.04,0.18-0.02,0.23,0.06c0.04,0.08,0.02,0.18-0.06,0.23c0,0,0,0,0,0 l-0.46,0.24c-0.08,0.04-0.18,0.01-0.22-0.07C154.97,59.56,155,59.47,155.08,59.42L155.08,59.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M156.55,58.58l0.43-0.27l0,0c0.08-0.05,0.19-0.03,0.25,0.06c0.05,0.08,0.03,0.19-0.06,0.25c0,0,0,0,0,0 l-0.44,0.27c-0.08,0.05-0.19,0.02-0.24-0.06C156.44,58.73,156.46,58.63,156.55,58.58L156.55,58.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M157.97,57.65l0.42-0.29l0,0c0.09-0.06,0.2-0.04,0.27,0.05c0.06,0.09,0.04,0.2-0.05,0.27c0,0,0,0,0,0 l-0.42,0.29c-0.09,0.06-0.2,0.04-0.26-0.05C157.86,57.82,157.88,57.71,157.97,57.65L157.97,57.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M159.33,56.64l0.4-0.32l0,0c0.09-0.07,0.21-0.06,0.28,0.03c0.07,0.09,0.06,0.21-0.03,0.28c0,0,0,0,0,0 l-0.41,0.32c-0.09,0.07-0.21,0.05-0.28-0.03C159.23,56.83,159.24,56.71,159.33,56.64L159.33,56.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M160.63,55.55l0.38-0.34l0,0c0.09-0.08,0.22-0.07,0.3,0.01c0.08,0.09,0.07,0.22-0.01,0.3c0,0,0,0,0,0 l-0.39,0.34c-0.09,0.08-0.22,0.07-0.3-0.02C160.53,55.76,160.54,55.63,160.63,55.55L160.63,55.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M161.85,54.38l0.35-0.37l0,0c0.09-0.09,0.23-0.09,0.32-0.01c0.09,0.09,0.09,0.23,0.01,0.32c0,0,0,0,0,0 l-0.36,0.37c-0.09,0.09-0.23,0.09-0.32,0C161.77,54.61,161.77,54.47,161.85,54.38L161.85,54.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M162.99,53.13l0.32-0.39l0,0c0.08-0.1,0.23-0.12,0.34-0.03c0.1,0.08,0.12,0.23,0.03,0.34c0,0,0,0,0,0 l-0.34,0.39c-0.08,0.1-0.23,0.11-0.33,0.03C162.92,53.38,162.91,53.23,162.99,53.13L162.99,53.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M164.04,51.8l0.29-0.41l0,0c0.08-0.11,0.24-0.14,0.35-0.06c0.11,0.08,0.14,0.24,0.06,0.35c0,0,0,0,0,0 l-0.31,0.42c-0.08,0.11-0.23,0.13-0.34,0.05C163.98,52.07,163.96,51.92,164.04,51.8L164.04,51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M164.98,50.4l0.26-0.43l0-0.01c0.07-0.12,0.23-0.16,0.35-0.09c0.12,0.07,0.16,0.23,0.09,0.35l0,0 l-0.27,0.44c-0.07,0.12-0.23,0.16-0.35,0.08C164.95,50.69,164.91,50.53,164.98,50.4L164.98,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M165.82,48.94l0.23-0.45l0-0.01c0.07-0.13,0.23-0.18,0.36-0.12c0.13,0.07,0.18,0.23,0.12,0.36l0,0 l-0.24,0.46c-0.07,0.13-0.22,0.18-0.35,0.12C165.8,49.23,165.75,49.07,165.82,48.94L165.82,48.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M166.52,47.41l0.18-0.47l0-0.01c0.05-0.14,0.21-0.21,0.35-0.15c0.14,0.05,0.21,0.21,0.15,0.35l0,0 l-0.19,0.48c-0.06,0.14-0.21,0.21-0.35,0.15C166.53,47.71,166.46,47.55,166.52,47.41L166.52,47.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M167.08,45.82l0.14-0.48l0-0.01c0.04-0.15,0.2-0.23,0.35-0.19c0.15,0.04,0.23,0.2,0.19,0.35l0,0l-0.15,0.5 c-0.04,0.15-0.2,0.23-0.35,0.19C167.12,46.13,167.04,45.98,167.08,45.82L167.08,45.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M167.5,44.19l0.1-0.5l0-0.01c0.03-0.16,0.18-0.26,0.34-0.23c0.16,0.03,0.26,0.18,0.23,0.34l0,0l-0.1,0.51 c-0.03,0.15-0.18,0.25-0.34,0.22C167.57,44.5,167.47,44.35,167.5,44.19L167.5,44.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M167.76,42.53l0.05-0.5l0-0.01c0.02-0.16,0.16-0.28,0.32-0.26c0.16,0.02,0.28,0.16,0.26,0.32l0,0 l-0.06,0.52c-0.02,0.16-0.16,0.28-0.32,0.26C167.86,42.84,167.75,42.7,167.76,42.53L167.76,42.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M167.88,40.86l0.01-0.5l0-0.01c0-0.17,0.14-0.3,0.31-0.3c0.17,0,0.3,0.14,0.3,0.31l0,0l-0.01,0.52 c0,0.17-0.14,0.3-0.31,0.29C168.01,41.16,167.88,41.03,167.88,40.86L167.88,40.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M167.84,39.18l-0.04-0.5l0-0.01c-0.01-0.17,0.11-0.32,0.28-0.33c0.17-0.01,0.32,0.11,0.33,0.28l0,0 l0.04,0.52c0.01,0.17-0.11,0.32-0.28,0.33C168,39.48,167.86,39.35,167.84,39.18L167.84,39.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M167.65,37.51l-0.09-0.5l0-0.01c-0.03-0.17,0.08-0.34,0.26-0.37c0.17-0.03,0.34,0.08,0.37,0.26l0,0 l0.09,0.51c0.03,0.17-0.09,0.33-0.26,0.36C167.84,37.8,167.68,37.69,167.65,37.51L167.65,37.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M167.3,35.87l-0.14-0.48l0-0.01c-0.05-0.17,0.05-0.35,0.22-0.4c0.17-0.05,0.35,0.05,0.4,0.22l0,0l0.14,0.5 c0.05,0.17-0.05,0.35-0.22,0.4C167.53,36.15,167.35,36.05,167.3,35.87L167.3,35.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M166.78,34.28l-0.19-0.47l0-0.01c-0.07-0.17,0.01-0.36,0.18-0.43c0.17-0.07,0.36,0.01,0.43,0.18l0,0 l0.19,0.49c0.07,0.17-0.02,0.36-0.19,0.43c-0.17,0.07-0.36-0.02-0.43-0.18L166.78,34.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M166.1,32.76l-0.24-0.44l-0.01-0.01c-0.09-0.16-0.03-0.37,0.14-0.46c0.16-0.09,0.37-0.03,0.46,0.14l0,0 l0.25,0.46c0.09,0.16,0.02,0.37-0.14,0.45C166.4,32.99,166.19,32.93,166.1,32.76L166.1,32.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M165.26,31.32l-0.29-0.41l-0.01-0.01c-0.11-0.15-0.07-0.37,0.08-0.47c0.15-0.11,0.37-0.07,0.47,0.08l0,0 l0.3,0.43c0.11,0.15,0.07,0.37-0.09,0.47C165.58,31.52,165.37,31.48,165.26,31.32L165.26,31.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M164.25,29.99c-0.11-0.12-0.22-0.25-0.33-0.37c-0.13-0.14-0.12-0.35,0.02-0.48 c0.14-0.13,0.35-0.12,0.48,0.02l0,0l0,0c0.12,0.13,0.23,0.26,0.35,0.39c0.13,0.14,0.11,0.36-0.03,0.48 C164.59,30.16,164.38,30.14,164.25,29.99L164.25,29.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M163.08,28.8l-0.38-0.33l-0.01-0.01c-0.14-0.13-0.16-0.34-0.03-0.49c0.13-0.14,0.34-0.16,0.49-0.03l0,0 l0.39,0.35c0.14,0.13,0.16,0.34,0.03,0.49C163.45,28.92,163.24,28.93,163.08,28.8L163.08,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M161.79,27.75l-0.41-0.28l-0.01-0.01c-0.16-0.11-0.2-0.33-0.09-0.48c0.11-0.16,0.33-0.2,0.48-0.09l0,0 l0.43,0.3c0.16,0.11,0.2,0.32,0.09,0.48C162.17,27.83,161.95,27.87,161.79,27.75L161.79,27.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M160.38,26.86l-0.44-0.24l-0.01-0.01c-0.17-0.09-0.23-0.3-0.14-0.47c0.09-0.17,0.3-0.23,0.47-0.14l0,0 l0.46,0.25c0.17,0.09,0.23,0.3,0.14,0.47C160.77,26.9,160.56,26.96,160.38,26.86L160.38,26.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M158.88,26.13l-0.46-0.19l-0.01,0c-0.18-0.07-0.27-0.28-0.19-0.46c0.07-0.18,0.28-0.27,0.46-0.19l0,0 l0.48,0.2c0.18,0.07,0.26,0.28,0.19,0.46C159.27,26.12,159.07,26.2,158.88,26.13L158.88,26.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M157.31,25.55l-0.48-0.14l-0.01,0c-0.19-0.06-0.29-0.25-0.24-0.44c0.06-0.19,0.25-0.29,0.44-0.24l0,0 l0.5,0.15c0.19,0.06,0.29,0.25,0.24,0.44C157.7,25.5,157.51,25.61,157.31,25.55L157.31,25.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M155.69,25.13l-0.49-0.09l-0.01,0c-0.19-0.04-0.32-0.22-0.28-0.42c0.04-0.19,0.22-0.32,0.42-0.28l0,0 l0.51,0.1c0.19,0.04,0.32,0.22,0.28,0.42C156.08,25.04,155.89,25.17,155.69,25.13L155.69,25.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M154.04,24.87l-0.5-0.05l-0.01,0c-0.2-0.02-0.34-0.19-0.32-0.39c0.02-0.2,0.19-0.34,0.39-0.32l0,0 l0.52,0.05c0.2,0.02,0.34,0.19,0.32,0.39C154.42,24.74,154.24,24.89,154.04,24.87L154.04,24.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M152.37,24.77l-0.5,0h-0.01c-0.2,0-0.36-0.16-0.36-0.36c0-0.2,0.16-0.36,0.36-0.36h0l0.52,0 c0.2,0,0.36,0.16,0.36,0.36C152.74,24.61,152.58,24.77,152.37,24.77L152.37,24.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M150.69,24.82l-0.5,0.05l-0.01,0c-0.2,0.02-0.38-0.13-0.4-0.33c-0.02-0.2,0.13-0.38,0.33-0.4l0,0l0.52-0.05 c0.2-0.02,0.38,0.13,0.4,0.33C151.05,24.63,150.9,24.8,150.69,24.82L150.69,24.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M149.04,25.05l-0.49,0.1l-0.01,0c-0.2,0.04-0.39-0.09-0.43-0.29c-0.04-0.2,0.09-0.39,0.29-0.43l0,0 l0.51-0.1c0.2-0.04,0.39,0.09,0.43,0.29C149.37,24.81,149.24,25.01,149.04,25.05L149.04,25.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M147.41,25.42l-0.48,0.14l-0.01,0c-0.2,0.06-0.4-0.06-0.46-0.25c-0.06-0.2,0.06-0.4,0.25-0.46l0,0l0.5-0.14 c0.2-0.06,0.4,0.06,0.46,0.25C147.72,25.16,147.61,25.36,147.41,25.42L147.41,25.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M145.81,25.93l-0.47,0.18l-0.01,0c-0.19,0.07-0.41-0.02-0.48-0.21c-0.07-0.19,0.02-0.41,0.21-0.48l0,0 l0.49-0.19c0.19-0.07,0.41,0.02,0.48,0.21C146.11,25.64,146.01,25.86,145.81,25.93L145.81,25.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M144.26,26.58l-0.45,0.22l-0.01,0c-0.19,0.09-0.41,0.01-0.5-0.17c-0.09-0.19-0.01-0.41,0.17-0.5l0,0 l0.47-0.22c0.19-0.09,0.41-0.01,0.5,0.18C144.53,26.26,144.46,26.49,144.26,26.58L144.26,26.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M142.77,27.35l-0.44,0.25l-0.01,0c-0.18,0.1-0.41,0.04-0.51-0.14c-0.1-0.18-0.04-0.41,0.14-0.51l0.45-0.26 c0.18-0.1,0.41-0.04,0.51,0.14C143.02,27.01,142.96,27.24,142.77,27.35L142.77,27.35L142.77,27.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M141.34,28.22l-0.42,0.28l-0.01,0c-0.17,0.12-0.4,0.07-0.52-0.1c-0.12-0.17-0.07-0.4,0.1-0.52l0.43-0.29 c0.17-0.12,0.4-0.07,0.52,0.1C141.56,27.87,141.52,28.1,141.34,28.22L141.34,28.22L141.34,28.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M139.97,29.2l-0.4,0.31l-0.01,0c-0.16,0.13-0.39,0.1-0.52-0.06c-0.13-0.16-0.1-0.39,0.06-0.52l0.41-0.32 c0.16-0.13,0.39-0.1,0.52,0.06C140.17,28.84,140.14,29.07,139.97,29.2L139.97,29.2L139.97,29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M138.68,30.28l-0.37,0.34l-0.01,0.01c-0.15,0.14-0.38,0.12-0.52-0.03c-0.14-0.15-0.13-0.38,0.02-0.52 l0.38-0.35c0.15-0.14,0.38-0.13,0.52,0.02C138.84,29.9,138.83,30.13,138.68,30.28L138.68,30.28L138.68,30.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M137.46,31.44l-0.35,0.36l-0.01,0.01c-0.14,0.14-0.37,0.15-0.51,0.01c-0.14-0.14-0.15-0.37-0.01-0.51 l0.36-0.38c0.14-0.15,0.37-0.15,0.52-0.01C137.6,31.05,137.6,31.28,137.46,31.44L137.46,31.44L137.46,31.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M136.32,32.68l-0.33,0.39l0,0.01c-0.13,0.15-0.36,0.17-0.51,0.04c-0.15-0.13-0.17-0.36-0.04-0.51l0.33-0.4 c0.13-0.15,0.36-0.17,0.51-0.05C136.43,32.29,136.45,32.52,136.32,32.68L136.32,32.68L136.32,32.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M135.26,33.99l-0.3,0.41l0,0c-0.12,0.16-0.34,0.19-0.5,0.07c-0.16-0.12-0.19-0.34-0.07-0.5l0.31-0.42 c0.12-0.16,0.34-0.19,0.5-0.07C135.35,33.6,135.38,33.82,135.26,33.99L135.26,33.99L135.26,33.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M134.28,35.36l-0.28,0.42l0,0c-0.11,0.16-0.33,0.21-0.49,0.1c-0.16-0.11-0.21-0.33-0.1-0.49l0.29-0.43 c0.11-0.16,0.33-0.21,0.49-0.1C134.34,34.97,134.39,35.19,134.28,35.36L134.28,35.36L134.28,35.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M133.36,36.78l-0.26,0.43l0,0c-0.1,0.17-0.32,0.22-0.48,0.12c-0.17-0.1-0.22-0.32-0.12-0.48l0.27-0.44 c0.1-0.17,0.32-0.22,0.49-0.12C133.41,36.39,133.46,36.61,133.36,36.78L133.36,36.78L133.36,36.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M132.5,38.24l-0.25,0.44l0,0c-0.09,0.17-0.31,0.23-0.48,0.13c-0.17-0.09-0.23-0.31-0.13-0.48l0.25-0.45 c0.09-0.17,0.31-0.23,0.48-0.14C132.53,37.85,132.59,38.07,132.5,38.24L132.5,38.24L132.5,38.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M131.68,39.73l-0.24,0.45l0,0c-0.09,0.17-0.3,0.23-0.47,0.14c-0.17-0.09-0.23-0.3-0.14-0.47l0.24-0.46 c0.09-0.17,0.3-0.24,0.47-0.15C131.7,39.34,131.77,39.56,131.68,39.73L131.68,39.73L131.68,39.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M130.89,41.24l-0.23,0.46l0,0c-0.09,0.17-0.29,0.24-0.46,0.15c-0.17-0.09-0.24-0.29-0.15-0.46l0.23-0.46 c0.09-0.17,0.29-0.24,0.46-0.15C130.91,40.86,130.98,41.06,130.89,41.24L130.89,41.24L130.89,41.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M130.12,42.76l-0.23,0.46c-0.08,0.17-0.29,0.24-0.46,0.15c-0.17-0.08-0.24-0.29-0.15-0.46l0.23-0.46 c0.08-0.17,0.29-0.24,0.46-0.16C130.14,42.38,130.21,42.59,130.12,42.76L130.12,42.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M129.37,44.29l-0.23,0.46c-0.08,0.17-0.29,0.24-0.45,0.15s-0.24-0.29-0.15-0.45l0.23-0.46 c0.08-0.17,0.29-0.24,0.45-0.16C129.38,43.92,129.45,44.12,129.37,44.29L129.37,44.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M128.6,45.82l-0.23,0.46c-0.08,0.17-0.29,0.23-0.45,0.15c-0.17-0.08-0.23-0.29-0.15-0.45l0,0l0.23-0.46l0,0 c0.08-0.17,0.29-0.23,0.45-0.15C128.62,45.45,128.69,45.65,128.6,45.82L128.6,45.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M127.82,47.34l-0.24,0.46c-0.08,0.16-0.28,0.22-0.44,0.14c-0.16-0.08-0.22-0.28-0.14-0.44l0,0l0.23-0.45 l0,0c0.08-0.16,0.28-0.23,0.45-0.14C127.84,46.98,127.91,47.18,127.82,47.34L127.82,47.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M127.01,48.85l-0.25,0.45c-0.09,0.15-0.28,0.21-0.44,0.12c-0.15-0.09-0.21-0.28-0.12-0.43l0,0l0.24-0.45 l0,0c0.09-0.16,0.28-0.21,0.44-0.13C127.04,48.5,127.09,48.7,127.01,48.85L127.01,48.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M126.15,50.34l-0.27,0.44c-0.09,0.15-0.28,0.19-0.43,0.1c-0.15-0.09-0.19-0.28-0.11-0.43l0,0l0.26-0.44l0,0 c0.09-0.15,0.28-0.2,0.43-0.11C126.19,50,126.24,50.19,126.15,50.34L126.15,50.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M125.23,51.8l-0.29,0.43c-0.09,0.14-0.28,0.18-0.42,0.08c-0.14-0.09-0.18-0.28-0.08-0.42l0,0l0.28-0.42l0,0 c0.09-0.14,0.28-0.18,0.42-0.09C125.29,51.47,125.33,51.66,125.23,51.8L125.23,51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M124.25,53.21l-0.31,0.42c-0.1,0.13-0.28,0.16-0.41,0.06c-0.13-0.1-0.16-0.28-0.06-0.41l0,0l0.3-0.41l0,0 c0.1-0.13,0.28-0.16,0.42-0.07C124.32,52.89,124.35,53.08,124.25,53.21L124.25,53.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M123.2,54.58l-0.33,0.4c-0.1,0.12-0.28,0.14-0.4,0.04c-0.12-0.1-0.14-0.28-0.04-0.4l0,0l0.32-0.39l0,0 c0.1-0.12,0.28-0.14,0.41-0.04C123.28,54.27,123.3,54.45,123.2,54.58L123.2,54.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M122.07,55.88l-0.35,0.38c-0.11,0.11-0.28,0.12-0.39,0.01c-0.11-0.1-0.12-0.28-0.01-0.39l0,0l0.34-0.37l0,0 c0.11-0.11,0.28-0.12,0.4-0.02C122.17,55.59,122.18,55.77,122.07,55.88L122.07,55.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M120.86,57.11l-0.38,0.35c-0.11,0.1-0.28,0.09-0.38-0.02c-0.1-0.11-0.09-0.28,0.01-0.38l0,0l0.37-0.35l0,0 c0.11-0.1,0.28-0.1,0.39,0.01C120.97,56.83,120.97,57.01,120.86,57.11L120.86,57.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M119.55,58.25l-0.41,0.32c-0.11,0.09-0.28,0.07-0.37-0.04c-0.09-0.11-0.07-0.28,0.04-0.37l0.01,0l0.39-0.32 l0.01,0c0.11-0.09,0.28-0.07,0.37,0.04C119.69,57.99,119.67,58.16,119.55,58.25L119.55,58.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M118.16,59.28l-0.44,0.28c-0.12,0.08-0.28,0.04-0.35-0.08c-0.08-0.12-0.04-0.27,0.07-0.35l0.01,0l0.42-0.28 l0.01,0c0.12-0.08,0.28-0.05,0.36,0.07C118.31,59.04,118.28,59.2,118.16,59.28L118.16,59.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M116.68,60.17l-0.46,0.24c-0.12,0.06-0.27,0.01-0.33-0.11c-0.06-0.12-0.01-0.26,0.1-0.33l0.01,0l0.45-0.24 l0.01,0c0.12-0.06,0.27-0.02,0.33,0.1C116.85,59.95,116.8,60.1,116.68,60.17C116.68,60.16,116.68,60.16,116.68,60.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M115.1,60.89l-0.49,0.18c-0.12,0.04-0.25-0.02-0.3-0.13c-0.04-0.12,0.01-0.25,0.13-0.29l0.01,0l0.47-0.19 l0.01,0c0.12-0.05,0.26,0.01,0.3,0.13C115.28,60.71,115.23,60.84,115.1,60.89C115.1,60.89,115.1,60.89,115.1,60.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M113.46,61.44c-0.17,0.04-0.34,0.09-0.5,0.13c-0.12,0.03-0.23-0.04-0.26-0.16 c-0.03-0.12,0.04-0.23,0.16-0.26l0,0c0.16-0.04,0.33-0.09,0.49-0.13l0.01,0c0.12-0.03,0.24,0.04,0.27,0.16 C113.65,61.29,113.58,61.41,113.46,61.44C113.46,61.44,113.46,61.44,113.46,61.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M111.75,61.78l-0.52,0.05c-0.11,0.01-0.21-0.07-0.22-0.18c-0.01-0.11,0.07-0.21,0.18-0.22l0.01,0l0.5-0.06 l0.01,0c0.11-0.01,0.22,0.07,0.23,0.18C111.95,61.66,111.87,61.76,111.75,61.78C111.76,61.78,111.75,61.78,111.75,61.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M110.01,61.84l-0.52-0.05c-0.1-0.01-0.18-0.1-0.17-0.21c0.01-0.1,0.1-0.18,0.2-0.17l0.01,0l0.5,0.04l0.01,0 c0.11,0.01,0.19,0.1,0.18,0.21C110.22,61.77,110.12,61.85,110.01,61.84C110.02,61.84,110.01,61.84,110.01,61.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M108.29,61.53c-0.17-0.06-0.33-0.11-0.5-0.18c-0.09-0.04-0.13-0.14-0.1-0.23c0.04-0.09,0.14-0.13,0.23-0.1 l0,0c0.15,0.06,0.31,0.11,0.47,0.16l0.02,0.01c0.09,0.03,0.14,0.14,0.11,0.23C108.49,61.52,108.39,61.57,108.29,61.53 C108.29,61.53,108.29,61.53,108.29,61.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M106.72,60.76l-0.42-0.33c-0.07-0.05-0.08-0.16-0.03-0.23c0.05-0.07,0.15-0.08,0.22-0.03l0.01,0.01l0.4,0.3 l0.01,0.01c0.07,0.06,0.09,0.16,0.03,0.23C106.9,60.8,106.79,60.82,106.72,60.76C106.72,60.76,106.72,60.76,106.72,60.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M105.47,59.52l-0.28-0.45c-0.04-0.07-0.02-0.16,0.05-0.2c0.07-0.04,0.15-0.02,0.2,0.04l0.01,0.01l0.27,0.41 l0.01,0.01c0.05,0.07,0.03,0.16-0.04,0.21C105.61,59.61,105.52,59.59,105.47,59.52C105.47,59.53,105.47,59.52,105.47,59.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M104.76,57.92l-0.06-0.39c-0.01-0.07,0.04-0.13,0.11-0.14c0.07-0.01,0.13,0.04,0.14,0.1l0,0.01l0.06,0.36 l0,0.01c0.01,0.07-0.03,0.14-0.11,0.15S104.77,57.99,104.76,57.92C104.76,57.92,104.76,57.92,104.76,57.92z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 3775.2229,
    y1: -1647.3867,
    x2: 3761.457,
    y2: -1655.7296,
    gradientTransform: "matrix(0.912 0.4103 -0.5366 0.7571 -4217.6665 -238.5977)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "104.63,53.62 102.92,56.22 101.9,53.94  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 3767.5828,
    y1: -1650.4713,
    x2: 3751.8298,
    y2: -1667.1283,
    gradientTransform: "matrix(0.912 0.4103 -0.5366 0.7571 -4217.6665 -238.5977)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M93.96,44.4l2.93,10.79c0.06,0.21,0.19,0.38,0.38,0.48c0.19,0.1,0.41,0.12,0.61,0.06l10.72-3.35 c0.12-0.04,0.21-0.15,0.22-0.28c0.01-0.13-0.06-0.25-0.17-0.31L93.96,44.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 3774.218,
    y1: -1647.5259,
    x2: 3761.3589,
    y2: -1655.3193,
    gradientTransform: "matrix(0.912 0.4103 -0.5366 0.7571 -4217.6665 -238.5977)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "104.63,53.62 93.96,44.4 102.91,54.17 102.46,54.91  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: -6501.2417,
    y1: -1432.3567,
    x2: -6495.3657,
    y2: -1434.0586,
    gradientTransform: "matrix(-0.912 -0.4103 -0.4103 0.912 -6411.8979 -1304.2396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "101.88,54.49 102.92,56.22 102.91,54.17  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.1662,
    y1: 63.6457,
    x2: 114.5245,
    y2: 72.0699
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M113.16,68.18c0,0,1.13,0.55,1.34,1.18c0.17,0.51,1.42,0.57,1.54,1.57c0.06,0.52,0.45,0.93,0.96,1.01 c1.28,0.2,3.25,0.86,3.56,3.08c0.24,1.69-0.62,2.34-1.53,2.56c-0.67,0.16-1.11,0.81-0.97,1.48c0.13,0.64-0.06,1.39-1.18,1.98 c-2.5,1.32-5-3.13-5-3.13l-0.51-7.77L113.16,68.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.2376,
    y1: 68.5127,
    x2: 110.4419,
    y2: 82.629
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5431C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C1119"
    }
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M101.37,64.08c0,0,3.22,8.78,8.71,11.52c0,0-1.83,2.98-2.78,3.16c0,0-5.86-7.5-6.46-13.65L101.37,64.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.4427,
    y1: 117.5783,
    x2: 126.2904,
    y2: 117.5783
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C4997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA4B7B"
    }
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M123.45,116.9l0.16,1.33c0.03,0.25,0.23,0.45,0.48,0.48c0.43,0.05,1.11,0.1,1.78,0.03 c0.29-0.03,0.49-0.33,0.4-0.61c-0.16-0.51-0.46-1.29-0.89-1.74h-1.48C123.62,116.39,123.41,116.62,123.45,116.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.4097,
    y1: 128.8081,
    x2: 115.5078,
    y2: 80.9121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5431C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C1119"
    }
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M111.88,101.3l-0.25,1.47c0,0,0.83,8.46,0.98,11.84c0.02,0.53-0.11,1.05-0.39,1.51l-1.45,2.36l3.69-2.18 l0.07-0.45l-0.6-0.83l0.79-9.47c0.05-0.56-0.07-1.11-0.33-1.61l-0.76-1.43L111.88,101.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.2125,
    y1: 117.0584,
    x2: 114.8203,
    y2: 117.0584
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C4997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA4B7B"
    }
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M110.52,118.81h1.18c0.22,0,0.43-0.1,0.56-0.28c0.37-0.48,1.13-1.41,1.49-1.43 c0.49-0.03,0.43,1.71,0.43,1.71h0.27l0.35-2.16c0.09-0.54-0.18-1.08-0.67-1.34l0,0c0,0-0.11,0.83-0.72,1.19 c-0.61,0.37-2.47,1.68-2.47,1.68s-0.23-0.03-0.48,0.01C110.09,118.26,110.15,118.81,110.52,118.81z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.6532,
    y1: 129.5208,
    x2: 123.7523,
    y2: 81.6122
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5431C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C1119"
    }
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M116.93,101.99c0,0,4.89,9.28,5.67,11.4c0.78,2.12,1.05,3.89,1.06,4.05c0.02,0.26,0.34,0.51,1.24,0.51 c0.46,0,0.69-0.19,0.8-0.36c0.09-0.15,0.1-0.34,0.02-0.51c-0.28-0.57-1.18-2.4-1.51-3.23c-0.4-0.99-1.25-5.48-1.72-7.04 c-0.47-1.56-1-3.25-3.04-4.82C119.45,101.99,118.05,100.62,116.93,101.99z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.5109,
    y1: 80.5079,
    x2: 113.5601,
    y2: 99.5193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CC246E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C266C"
    }
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M113.84,86.79c-1.26-5.35,1.93-8.37,1.93-8.37c-2.02-1.94-5.69-2.82-5.69-2.82s-3.51,2.56-3.09,4.57 c0.24,1.18,2.46,7.04,2.46,7.04S111.51,88.19,113.84,86.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.7985,
    y1: 81.4413,
    x2: 112.5528,
    y2: 97.8344
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CC246E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C266C"
    }
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M116.64,89.44c-0.51-1.55-2.8-2.65-2.8-2.65c-2.33,1.4-4.38,0.43-4.38,0.43s-0.46,1.76-0.14,3.4 s2.31,12.15,2.31,12.15c3.14,0.64,7.97-0.64,7.97-0.64C117.6,98.57,117.15,90.98,116.64,89.44z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_113_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.9603,
    y1: 81.597,
    x2: 111.7301,
    y2: 75.9653
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5431C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C1119"
    }
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M112.38,72.07l1.03,4.61c0.1,0.41-0.27,0.34-0.68,0.26c-0.67-0.13-1.54-0.39-1.83-0.91 c-0.03-0.05-0.04-0.11-0.05-0.17l-0.44-3.2c-0.03-0.25,0.1-0.5,0.34-0.6l0.85-0.38C111.91,71.54,112.29,71.72,112.38,72.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.133,
    y1: 84.3414,
    x2: 119.2468,
    y2: 84.3414
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5431C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C1119"
    }
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M115.78,78.42c0,0,7.16,5.12,0.92,10.5c0,0-0.24,0.27-0.71,0.41c-0.24,0.07-0.94,0.6-1.29,0.88 c-0.11,0.09-0.28,0.06-0.36-0.06l0,0c-0.06-0.1-0.07-0.22-0.02-0.32l0.89-1.87c0.25-0.23,0.62-0.25,0.89-0.04h0 c0.17,0.13,0.42,0.08,0.51-0.12c0.48-0.98,1.39-3.87-2.34-7.14c-0.14-0.12-0.18-0.33-0.09-0.49 C114.44,79.66,115.04,78.66,115.78,78.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.0173,
    y1: 74.336,
    x2: 115.7339,
    y2: 62.3827
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5431C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C1119"
    }
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M111.17,67.68c0,0-1.21,0.51-2.04,2.27c-0.83,1.76-0.21,2.57,0.57,2.68c0.77,0.11,1.93,0.09,3.16-1.04 C114.08,70.46,112.75,67.08,111.17,67.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.4617,
    y1: 63.9266,
    x2: 113.8199,
    y2: 72.3508
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M112.03,70.65c0,0,0.92-2.57-1.36-2.6l-0.54,0.37c0,0-0.84-1.42,0.54-2.1c1.37-0.68,2.98-0.12,3.56,1.73 c0.58,1.85,0.68,3.08-0.29,3.97c-0.97,0.88-1.37-0.12-1.37-0.12s0.53-0.83,0.31-1.27s-0.71,0.09-0.71,0.09L112.03,70.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.447,
    y1: 75.1394,
    x2: 117.1636,
    y2: 63.1861
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5431C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C1119"
    }
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M112.29,70.94c0,0,0.46-1.32,1.08-0.8c0.62,0.53-0.5,1.22-0.94,1.45L112.29,70.94z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.0116,
    y1: 69.0516,
    x2: 109.2159,
    y2: 83.1679
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5431C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C1119"
    }
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M101.07,65.68c-0.05,0.16,0.52,0.39,0.85-0.24c0.01-0.31,0.2-1.62,0.01-1.87 c-0.97-1.33-2.86-2.99-2.86-2.99c-0.32,0.32-0.06,0.62-0.06,0.62l0.92,0.95c-0.19,0.35-0.43,0.64-0.54,1.06 c-0.08,0.32-0.03,0.66,0.13,0.95c0.16,0.29,0.38,0.67,0.59,0.96C100.51,65.67,101.07,65.68,101.07,65.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_119_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.0628,
    y1: 63.8466,
    x2: 101.5106,
    y2: 63.8466
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5431C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C1119"
    }
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M100.6,65.02c-0.07-0.38-0.28-1.43-0.43-1.67c-0.1-0.16-0.13-0.3-0.1-0.42c0.03-0.1,0.1-0.18,0.22-0.24 l0.05-0.03l0.9,0.76l0.27,0.73l-0.16,0.06l-0.25-0.68l-0.77-0.65c-0.05,0.03-0.07,0.07-0.08,0.1c-0.02,0.07,0.01,0.16,0.08,0.28 c0.19,0.31,0.44,1.67,0.45,1.73L100.6,65.02z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: -2053.7476,
    y1: 124.881,
    x2: -2066.2366,
    y2: 137.8644,
    gradientTransform: "matrix(-0.9667 -0.2558 -0.2558 0.9667 -1815.4387 -553.958)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CC246E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C266C"
    }
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M135.46,113.55c0,0,5.97,8.64,12.24,6.15c5.04-2-1.72-2.2-7.21-4.18c-0.43-0.16-0.23-0.8,0.22-0.68 c4.35,1.17,11.04,2.55,12.52,0.39c2.23-3.25,0.37-2.35-5.09-2.56c-5.46-0.21-6.32-1.68-2.69-2.04c3.63-0.36,8.98,2.21,10.51,0.68 c1.53-1.53,2.69-4.82,3.4-6.21c0.71-1.39-6.23-4.53-8.43-2.88c-2.21,1.65-4.36,5.71-6.78,6.18c-2.42,0.47,0.57-2.97,2.37-4.71 c1.8-1.74,2.6-3.11-0.54-3.05c-3.13,0.06-5.26,3.59-5.95,6.35c-0.69,2.76-1.98,4.18-1.75,2.8c0.23-1.38,1.3-5.56,2.45-6.71 C141.88,101.94,134.66,102.57,135.46,113.55z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M136.02,113.7c0.03,0.02,0.07,0.02,0.1,0c6.7-4.46,17.27-6.94,17.38-6.96c0.05-0.01,0.08-0.06,0.07-0.11 c-0.01-0.05-0.06-0.08-0.11-0.07c-0.11,0.02-10.71,2.52-17.44,6.99c-0.04,0.03-0.05,0.09-0.03,0.13 C136,113.68,136.01,113.69,136.02,113.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_121_",
    gradientUnits: "userSpaceOnUse",
    x1: -2066.1309,
    y1: 151.2688,
    x2: -2036.0753,
    y2: 113.1682,
    gradientTransform: "matrix(-0.9667 -0.2558 -0.2558 0.9667 -1815.4387 -553.958)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CC246E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C266C"
    }
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M130.59,117.92c0,0,12.72,2.11,15.88-5.54c2.55-6.15-3.4-0.36-9.85,2.78c-0.51,0.25-0.9-0.49-0.42-0.78 c4.75-2.83,11.68-7.56,11.04-10.7c-0.96-4.74-1.76-2.33-6.6,2.3c-4.85,4.63-6.88,4.14-4.1,0.63c2.78-3.51,9.62-6.03,9.58-8.69 c-0.04-2.66-1.95-6.49-2.57-8.3c-0.61-1.81-9.31,1.62-9.74,4.98c-0.43,3.36,1.31,8.72-0.35,11.26c-1.65,2.54-2.13-3.04-2.13-6.11 c0-3.07-0.52-4.95-3.15-2.13c-2.63,2.81-1.32,7.7,0.51,10.67c1.84,2.97,1.99,5.32,0.97,3.94c-1.02-1.38-3.79-5.89-3.82-7.89 C125.83,102.34,120.22,109.24,130.59,117.92z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M131.2,117.55c0.04-0.01,0.07-0.04,0.08-0.09c1.79-9.71,8.64-21.16,8.71-21.27 c0.03-0.05,0.02-0.12-0.04-0.16c-0.05-0.03-0.12-0.01-0.16,0.04c-0.07,0.11-6.93,11.59-8.73,21.35 c-0.01,0.06,0.03,0.12,0.09,0.13C131.16,117.56,131.18,117.56,131.2,117.55z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTest);
export default __webpack_public_path__ + "static/media/icon_test.0730b0ec25ff8352d3adc00fae6653a1.svg";
export { ForwardRef as ReactComponent };